import React , { createRef } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteAUser, loadUsersData, saveAUser, updateAUser, loadSingleUserData} from "../../redux/modules/user";
import {loadDispatchsheetsData, deleteADispatchsheet, saveADispatchsheet, updateADispatchsheet, updateADispatchsheetPath, clearDispatchErrorMsg} from "../../redux/modules/dispatchsheet";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
//import * as Select2 from 'react-select'
import MenuItem from "@material-ui/core/MenuItem";
import {decodeVin} from "../../redux/modules/vin";
import GridList from "@material-ui/core/GridList";
import CardUserInformation from "./CardUserInformation";
import {loadCompanysData, selectACompany} from "../../redux/modules/company";
import {  loadPoliceData  } from "../../redux/modules/police";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
/*
import {
  deleteATowCompanyTruck,
  loadTowCompanyTrucksData,
  saveATowCompanyTruck,
  updateATowCompanyTruck,
  clearTowCompanyTruckErrorMsg,
} from "../../redux/modules/towcompanytruck";
import {
  deleteATowCompanyDriver,
  loadTowCompanyDriversData,
  saveATowCompanyDriver,
  updateATowCompanyDriver,
  clearTowCompanyDriverErrorMsg,
} from "../../redux/modules/towcompanydriver";

 */

import Avatar from '@material-ui/core/Avatar';
import Image from 'material-ui-image';
import { TimePicker,DatePicker, DateTimePicker, KeyboardDateTimePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";

//import { TimePicker,DatePicker, DateTimePicker,LocalizationProvider} from "@mui/x-date-pickers";

//import {loadLocationsData} from "../../redux/modules/location";
import DateFnsUtils from "@date-io/date-fns";
/* import {
    MuiPickersUtilsProvider,
    TimePicker,
    DatePicker,
} from 'material-ui-pickers';
*/
//import {  KeyboardDateTimePicker } from "@material-ui/pickers";
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

//import {Radio as Radio1} from 'react-radio-group';
//import {RadioGroup as RadioGroup1} from 'react-radio-group';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Divider from "@material-ui/core/Divider";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import {Document, Page} from "react-pdf";
import Tooltip from "@material-ui/core/Tooltip";
import * as MainConstants from "../../utils/MainConstants";
import InputMask from "react-input-mask";
import {FilePicker} from "react-file-picker";
import {uploadATowPicture} from "../../redux/modules/towjob";
import {loadTowCompanyDriversData} from "../../redux/modules/towcompanydriver";
import {loadTowCompanyTrucksData} from "../../redux/modules/towcompanytruck";
//import DatePickerB from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";


const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 100,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
    //backgroundColor:"#fa692a",
    backgroundColor: "#09bebd",
    color:"black",
    textTransform: "unset !important",
  },
  
  decodebutton: {
    marginTop: theme.spacing.unit * 1,
    marginLeft: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*3,
    backgroundColor:"#e2580d",
    color:"black",
    textTransform: "unset !important",
  },
  
  gridList: {
    width: 500,
    height:500,
  },
  dividerColor1: {
    //marginTop: theme.spacing.unit * 3,
    //color:"#eb3440",
    //backgroundColor:"#eb3440",
    
    color:"#408587",
    backgroundColor:"#408587",
    marginBottom:'10px',
    
    
  },
  dividerColor2: {
    //marginTop: theme.spacing.unit * 3,
    color:"#b134eb",
    backgroundColor:"#b134eb",
    
  },
  
  dialogtext: {
    //marginTop: theme.spacing.unit * 3,
    color:"#380202",
    backgroundColor:"#ffffff",
    
  },
  dialogheader: {
    //marginTop: theme.spacing.unit * 3,
    color:"#380202",
    backgroundColor:"#d41919",
    
  },
  textFieldColor:{
    color:"black",
    background:"#CCCCFF",
  },
  
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const tempDate = new Date("2018/01/01 01:01 PM");
class DispatcherLogform extends React.Component {
  
  
  state = {
    
    //selectedLocation:{},
    dispatch:{    "claimnumber":"", "istruck":"no", "etaDate":null, "callDate":null, "country":"U.S.A", "state":"Massachusetts"},
    selectedUser:{},
    alterState:true,
    inputFieldShrinkState:true,
    selectedCompany:{"country":"U.S.A", "state":"Massachusetts"},
    selectedPolice:{"country":"U.S.A", "state":"Massachusetts"},
    selectedDriver:{},
    selectedTruck:{},
    selectedVehicleCountry:"U.S.A",
    selectedVehicleState:"Massachusetts",
    showFaxSelectDialog:false,
    receivedbyHelperText:"",
    receivedbyError:false,
    callDateHelperText:"",
    callDateError:false,
    etaDateHelperText:"",
    etaDateError:false,
    nameHelperText:"",
    nameError:false,
    callbacknumberHelperText:"",
    callbacknumberError:false,
    locationHelperText:"",
    locationError:false,
    townHelperText:"",
    townError:false,
    bodyHelperText:"",
    bodyError:false,
    typeHelperText:"",
    typeError:false,
    vinHelperText:"",
    vindError:false,
    yearHelperText:"",
    yearError:false,
    makeHelperText:"",
    makeError:false,
    modelHelperText:"",
    modelError:false,
    colorHelperText:"",
    colorError:false,
    plateHelperText:"",
    plateError:false,
    stateHelperText:"",
    stateError:false,
    countryHelperText:"",
    countryError:false,
    unitsizeHelperText:"",
    unitsizeError:false,
    unitnumberHelperText:"",
    unitnumberError:false,
    otherHelperText:"",
    otherError:false,
    vehicletypeHelperText:"",
    vehicletypeError:false,
    drivetypeHelperText:"",
    drivetypeError:false,
    lockouthubHelperText:"",
    lockouthubError:false,
    passengersHelperText:"",
    passengersError:false,
    truckloadedHelperText:"",
    truckloadedError:false,
    heightHelperText:"",
    heightError:false,
    totalweightHelperText:"",
    totalweightError:false,
    dualrearwheelHelperText:"",
    dualrearwheelError:false,
    hookuptypeHelperText:"",
    hookuptypeError:false,
    ballsizeHelperText:"",
    ballsizeError:false,
    calltypeHelperText:"",
    calltypeError:false,
    towreasonHelperText:"",
    towreasonError:false,
    safelocationHelperText:"",
    safelocationError:false,
    destinationHelperText:"",
    destinationError:false,
    damageHelperText:"",
    damageError:false,
    attendedHelperText:"",
    attendedError:false,
    ispoHelperText:"",
    ispoError:false,
    keylocationHelperText:"",
    keylocationError:false,
    contactHelperText:"",
    contactError:false,
    requestedbyHelperText:"",
    requestedbyError:false,
    amountquotedHelperText:"",
    amountquotedError:false,
    paymentmethodHelperText:"",
    paymentmethodError:false,
    billtoHelperText:"",
    billtoError:false,
    ponumberHelperText:"",
    ponumberError:false,
    policynumberHelperText:"",
    policynumberError:false,
    overageamountHelperText:"",
    overageamountError:false,
    claimnumberHelperText:"",
    claimnumberError:false,
    commentHelperText:"",
    commentError:false,
    driverHelperText:"",
    driverError:false,
    trucknumberHelperText:"",
    trucknumberError:false,
    dispatchedbyHelperText:"",
    dispatchedbyError:false,
    dispatchdateHelperText:"",
    dispatchdateError:false,
    //dispatchtimeHelperText:"",
    //dispatchtimeError:false,
    servicetypeHelperText:"",
    servicetypeError:false,
    istrailerHelperText:"",
    istrailerError:false,
    istruckHelperText:"",
    istruckError:false,
    filepathHelperText:"",
    filepathError:false,
    selectedPoliceHelperText:"",
    selectedPoliceError:false,
    open:false,
    showFormDialog:false,
    callDateK:new Date("2019-01-01T18:54"),
    clearFields:false,
    showDispatchSavedDialog:false,
    verify:'yes',
  };
  
  
  
  constructor(props) {
    super(props);
    
    this.companySelectList=null;
    this.policeSelectList=null;
    this.driversSelectList=null;
    this.trucksSelectList=null;
    //this.state.dispatch.dispatchdate=new Date(0);
    //this.isTruckRef = createRef();
    
    //this.editRecord = this.editRecord.bind(this);
    this.deleteRecord = this.deleteRecord.bind(this);
    
    this.damage = React.createRef();
    this.clearFields = this.clearFields.bind(this);
    this.refresh = this.refresh.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleFirstnameChange = this.handleFirstnameChange.bind(this);
    //this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleAddress1Change = this.handleAddress1Change.bind(this);
    this.handleLastnameChange = this.handleLastnameChange.bind(this);
    
    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
    //this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    //this.getListOfUsers = this.getListOfUsers.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    
    
    this.handleCallDateChange = this.handleCallDateChange.bind(this);
    //this.handleCallTimeChange = this.handleCallTimeChange.bind(this);
    this.handleETATimeChange = this.handleETATimeChange.bind(this);
    this.handleReceivedByChange = this.handleReceivedByChange.bind(this);
    
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleCallBackNumberChange = this.handleCallBackNumberChange.bind(this);
    this.handleLocationChange = this.handleLocationChange.bind(this);
    this.handleTownChange = this.handleTownChange.bind(this);
    
    this.handleBodyChange = this.handleBodyChange.bind(this);
    this.handleTypeChange = this.handleTypeChange.bind(this);
    this.handleVinChange = this.handleVinChange.bind(this);
    
    
    this.handleYearChange = this.handleYearChange.bind(this);
    this.handleMakeChange = this.handleMakeChange.bind(this);
    this.handleModelChange = this.handleModelChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handlePlateChange = this.handlePlateChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    
    this.handleUnitsizeChange = this.handleUnitsizeChange.bind(this);
    this.handleUnitnumberChange = this.handleUnitnumberChange.bind(this);
    this.handleOtherChange = this.handleOtherChange.bind(this);
    
    this.handleVehicleTypeChange = this.handleVehicleTypeChange.bind(this);
    this.handleDriveTypeChange = this.handleDriveTypeChange.bind(this);
    this.handleHubTypeChange = this.handleHubTypeChange.bind(this);
    this.handlePassengersChange = this.handlePassengersChange.bind(this);
    this.handleTruckLoadedChange = this.handleTruckLoadedChange.bind(this);
    this.handleHeightChange = this.handleHeightChange.bind(this);
    this.handleTotalWeightChange = this.handleTotalWeightChange.bind(this);
    this.handleDualRearWheelChange = this.handleDualRearWheelChange.bind(this);
    this.handleHookupTypeChange = this.handleHookupTypeChange.bind(this);
    this.handleBallSizeChange = this.handleBallSizeChange.bind(this);
    this.handleCallTypeChange = this.handleCallTypeChange.bind(this);
    this.handleTowReasonChange = this.handleTowReasonChange.bind(this);
    this.handleSafeLocationChange = this.handleSafeLocationChange.bind(this);
    this.handleDestinationChange = this.handleDestinationChange.bind(this);
    this.handleDamageChange = this.handleDamageChange.bind(this);
    this.handleVerifyRadioChange = this.handleVerifyRadioChange.bind(this);
    this.handleAttendedChange = this.handleAttendedChange.bind(this);
    this.handleKeyLocationChange = this.handleKeyLocationChange.bind(this);
    this.handleIspoChange = this.handleIspoChange.bind(this);
    this.handleContactChange = this.handleContactChange.bind(this);
    this.handleRequestedbyChange = this.handleRequestedbyChange.bind(this);
    this.handleAmountquotedChange = this.handleAmountquotedChange.bind(this);
    this.handlePaymentMethodChange = this.handlePaymentMethodChange.bind(this);
    this.handleBilltoChange = this.handleBilltoChange.bind(this);
    this.handlePONumberChange = this.handlePONumberChange.bind(this);
    this.handlePolicyNumberChange = this.handlePolicyNumberChange.bind(this);
    this.handleOverageamountChange = this.handleOverageamountChange.bind(this);
    this.handleClaimNumberChange = this.handleClaimNumberChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    
    this.handleDriverChange = this.handleDriverChange.bind(this);
    this.handleTrucknumberChange = this.handleTrucknumberChange.bind(this);
    this.handleDispatchbyChange = this.handleDispatchbyChange.bind(this);
    
    //this.handleDispatchTimeChange = this.handleDispatchTimeChange.bind(this);
    this.handleDispatchDateChange = this.handleDispatchDateChange.bind(this);
    
    this.handleServiceTypeChange = this.handleServiceTypeChange.bind(this);
    this.handleIsTrailerChange = this.handleIsTrailerChange.bind(this);
    this.handleCompanyChange = this.handleCompanyChange.bind(this);
    this.handlePoliceChange = this.handlePoliceChange.bind(this);
    this.handleIsTruckChange = this.handleIsTruckChange.bind(this);
    this.handleClickShowDispatchLog = this.handleClickShowDispatchLog.bind(this);
    this.getListOfPoliceDepartmentsForSelection = this.getListOfPoliceDepartmentsForSelection.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    
    this.handleClickFormDialog = this.handleClickFormDialog.bind(this);
    this.handleClickShowFormDialogClose = this.handleClickShowFormDialogClose.bind(this);
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.downloadDispatchData = this.downloadDispatchData.bind(this);
    this.handleEditModeChange= this.handleEditModeChange.bind(this);
    this.getPoliceInfoFromPoliceId= this.getPoliceInfoFromPoliceId.bind(this);
    this.getCompanyInfoFromCompanyId= this.getCompanyInfoFromCompanyId.bind(this);
    this.handleCallDateChangeK= this.handleCallDateChangeK.bind(this);
    this.reformatDate= this.reformatDate.bind(this);
    this.handleDecodeVin=this.handleDecodeVin.bind(this);
    this.handleClickShowSavedDispatchClose= this.handleClickShowSavedDispatchClose.bind(this);
    this.handleClickShowSavedDispatch= this.handleClickShowSavedDispatch.bind(this);
    this.getListOfDriversForSelection= this.getListOfDriversForSelection.bind(this);
    this.getListOfTrucksForSelection= this.getListOfTrucksForSelection.bind(this);
    this.handleDisptach= this.handleDisptach.bind(this);
    this.handleEnroute= this.handleEnroute.bind(this);
    this.handleOnscene= this.handleOnscene.bind(this);
    this.handleTowing= this.handleTowing.bind(this);
    this.handleCompleted= this.handleCompleted.bind(this);
    this.handleUploadSelectedFile = this.handleUploadSelectedFile.bind(this);
    this.hadleLoadedFile = this.hadleLoadedFile.bind(this);
    this.getDriverInfoFromDriverId = this.getDriverInfoFromDriverId.bind(this);
    this.getTruckInfoFromDriverId = this.getTruckInfoFromDriverId.bind(this);
    
    
    
    
    
    
    
  }
  
  
  handleDecodeVin(){
    let { decodeVin } = this.props;
    decodeVin(this.state.dispatch.vin);
  }
  
  downloadDispatchData () {
    var fileName = this.state.dispatch.plate+".pdf";
    fetch(this.props.dispatchsheetPath)
      .then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
        });
        //window.location.href = response.url;
      });
  }
  
  
  handleClickFormDialog() {
    //let {loadPdfFile} = this.props;
    //loadPdfFile(DEFAULT_VESPAAN_SERVER.url);
    
    
    this.setState({showFormDialog:true});
    
  };
  
  handleClickShowFormDialogClose() {
    this.setState({showFormDialog:false});
  };
  
  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }
  
  
  handleDisptach (event) {
    event.preventDefault();
    
    let { updateADispatchsheet} = this.props;
    let tempError = false
    this.setState(Object.assign(this.state.dispatch,{status:'Dispatched'}));
    var tempDispatch = this.state.dispatch;
    updateADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    
  }
  
  handleEnroute(event) {
    event.preventDefault();
    
    let { updateADispatchsheet} = this.props;
    let tempError = false
    this.setState(Object.assign(this.state.dispatch,{status:'Enroute'}));
    var tempDispatch = this.state.dispatch;
    updateADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    
  }
  
  handleOnscene (event) {
    event.preventDefault();
    
    let { updateADispatchsheet} = this.props;
    let tempError = false
    this.setState(Object.assign(this.state.dispatch,{status:'Onscene'}));
    var tempDispatch = this.state.dispatch;
    updateADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    
  }
  
  handleTowing (event) {
    event.preventDefault();
    
    let { updateADispatchsheet} = this.props;
    let tempError = false
    this.setState(Object.assign(this.state.dispatch,{status:'Towing'}));
    var tempDispatch = this.state.dispatch;
    updateADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    
  }
  
  handleCompleted (event) {
    event.preventDefault();
    
    let { updateADispatchsheet} = this.props;
    let tempError = false
    this.setState(Object.assign(this.state.dispatch,{status:'Complete'}));
    var tempDispatch = this.state.dispatch;
    updateADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    
  }
  
  
  handleSubmit (event) {
    event.preventDefault();
    
    let { saveADispatchsheet, updateADispatchsheetPath } = this.props;
    
    let tempError= false
    
    var tempDispatch = this.state.dispatch;
    /*tempDispatch.driverfirstname =  this.state.selectedDriver.firstname;
	tempDispatch.driverlastname =  this.state.selectedDriver.lastname;
	tempDispatch.driverid =  this.state.selectedDriver.id;
	
		tempDispatch.trucknumber =  this.state.selectedTruck.truckid;
	tempDispatch.truckid =  this.state.selectedTruck.id;
	tempDispatch.truckmake =  this.state.selectedTruck.make;
	tempDispatch.truckmodel =  this.state.selectedTruck.model;
	*/
    
    
    tempDispatch.make= this.props.decodedVinVehicleObject.make;
    tempDispatch.model=this.props.decodedVinVehicleObject.model;
    tempDispatch.body=this.props.decodedVinVehicleObject.body;
    tempDispatch.type=this.props.decodedVinVehicleObject.type;
    tempDispatch.year=this.props.decodedVinVehicleObject.year;
    
    //tempDispatch.towcompanyid=this.state.selectedCompany.id;
    tempDispatch.towcompanyid= this.props.selectedCompany;
    if((this.state.selectedPolice != null) &&  (this.state.selectedPolice != undefined)){
      tempDispatch.policeid = this.state.selectedPolice.id;
      tempDispatch.policedepartmentname=  this.state.selectedPolice.departmentname;
    }
    
    if((this.state.selectedTruck != null) &&  (this.state.selectedTruck != undefined)){
      tempDispatch.truckid = this.state.selectedTruck.id;
      tempDispatch.trucknumber = this.state.selectedTruck.truckid;
      tempDispatch.truckmake=  this.state.selectedTruck.make;
      tempDispatch.truckmodel=  this.state.selectedTruck.model;
    }
    
    if((this.state.selectedDriver != null) &&  (this.state.selectedDriver!= undefined)){
      tempDispatch.driverid = this.state.selectedDriver.id;
      tempDispatch.driverfirstname=  this.state.selectedDriver.firstname;
      tempDispatch.driverlastname=  this.state.selectedDriver.lastname;
    }
    //Check for these two ID and make sure they are set.
    
    
    
    
    if((tempDispatch.callDate == null) ||  (tempDispatch.callDate== undefined)){
      this.setState({callDateError:true});
      this.setState({callDateHelperText:"Required"});
      tempError= true;
    }
    
    
    
    /*if((tempDispatch.calltime == null) ||  (tempDispatch.calltime== undefined)){
				this.setState({calltimeError:true});
				this.setState({calltimeHelperText:"Required"});
				tempError= true;
		}*/
    
    
    if((tempDispatch.etaDate == null) ||  (tempDispatch.etaDate== undefined)){
      this.setState({etaDateError:true});
      this.setState({etaDateError:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.receivedby == undefined) ||  (tempDispatch.receivedby.length == 0)){
      this.setState({receivedbyError:true});
      this.setState({receivedbyHelperText:"Required"});
      tempError= true;
    }
    
    
    if((tempDispatch.policynumber == undefined) ||  (tempDispatch.policynumber.length == 0)){
      this.setState({policynumberError:true});
      this.setState({policynumberHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.name == undefined) ||  (tempDispatch.name.length == 0)){
      this.setState({nameError:true});
      this.setState({nameHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.callbacknumber == undefined) ||  (tempDispatch.callbacknumber.length == 0)){
      this.setState({callbacknumberError:true});
      this.setState({callbacknumberHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.location == undefined) ||  (tempDispatch.location.length == 0)){
      this.setState({locationError:true});
      this.setState({locationHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.town == undefined) ||  (tempDispatch.town.length == 0)){
      this.setState({townError:true});
      this.setState({townHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.year == undefined) ||  (tempDispatch.year.length == 0)){
      this.setState({yearError:true});
      this.setState({yearHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.make == undefined) ||  (tempDispatch.make.length == 0)){
      this.setState({makeError:true});
      this.setState({makeHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.model == undefined) ||  (tempDispatch.model.length == 0)){
      this.setState({modelError:true});
      this.setState({modelHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.color == undefined) ||  (tempDispatch.color.length == 0)){
      this.setState({colorError:true});
      this.setState({colorHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.plate == undefined) ||  (tempDispatch.plate.length == 0)){
      this.setState({plateError:true});
      this.setState({plateHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.body == undefined) ||  (tempDispatch.body.length == 0)){
      this.setState({bodyError:true});
      this.setState({bodyHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({bodyError:false});
      this.setState({bodyHelperText:""});
    }
    
    if((tempDispatch.type == undefined) ||  (tempDispatch.type.length == 0)){
      this.setState({typeError:true});
      this.setState({typeHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({typeError:false});
      this.setState({typeHelperText:""});
    }
    
    
    
    
    if((tempDispatch.state == undefined) ||  (tempDispatch.state.length == 0)){
      this.setState({stateError:true});
      this.setState({stateHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({stateError:false});
      this.setState({stateHelperText:""});
    }
    
    if((tempDispatch.country == undefined) ||  (tempDispatch.country.length == 0)){
      this.setState({countryError:true});
      this.setState({countryHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({countryError:false});
      this.setState({countryHelperText:""});
    }
    
    if((tempDispatch.unitsize == undefined) ||  (tempDispatch.unitsize.length == 0)){
      this.setState({unitsizeError:true});
      this.setState({unitsizeHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({unitsizeError:false});
      this.setState({unitsizeHelperText:""});
    }
    
    if((tempDispatch.unitnumber == undefined) ||  (tempDispatch.unitnumber.length == 0)){
      this.setState({unitnumberError:true});
      this.setState({unitnumberHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({unitnumberError:false});
      this.setState({unitnumberHelperText:""});
    }
    
    if((tempDispatch.other == undefined) ||  (tempDispatch.other.length == 0)){
      this.setState({otherError:true});
      this.setState({otherHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({otherError:false});
      this.setState({otherHelperText:""});
    }
    
    
    
    
    if((tempDispatch.vehicletype == undefined) ||  (tempDispatch.vehicletype.length == 0)){
      this.setState({vehicletypeError:true});
      this.setState({vehicletypeHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({vehicletypeError:false});
      this.setState({vehicletypeHelperText:""});
    }
    
    if((tempDispatch.drivetype == undefined) ||  (tempDispatch.drivetype.length == 0)){
      this.setState({drivetypeError:true});
      this.setState({drivetypeHelperText:"Required"});
      tempError= true;
    }else{
      this.setState({drivetypeError:false});
      this.setState({drivetypeHelperText:""});
    }
    
    if((tempDispatch.lockouthub == undefined) ||  (tempDispatch.lockouthub.length == 0)){
      this.setState({lockouthubError:true});
      this.setState({lockouthubHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.passengers == undefined) ||  (tempDispatch.passengers.length == 0)){
      this.setState({passengersError:true});
      this.setState({passengersHelperText:"Required"});
      tempError= true;
    }
    
    
    if((tempDispatch.istruck == undefined) ||  (tempDispatch.istruck.length == 0)){
      this.setState({istruckError:true});
      this.setState({istruckHelperText:"Required"});
      tempError= true;
      
      if((tempDispatch.truckloaded == undefined) ||  (tempDispatch.truckloaded.length == 0)){
        this.setState({truckloadedError:true});
        this.setState({truckloadedHelperText:"Required"});
        tempError= true;
      }
      
      if((tempDispatch.height == undefined) ||  (tempDispatch.height.length == 0)){
        this.setState({heightError:true});
        this.setState({heightHelperText:"Required"});
        tempError= true;
      }
      
      if((tempDispatch.totalweight == undefined) ||  (tempDispatch.totalweight.length == 0)){
        this.setState({totalweightError:true});
        this.setState({totalweightHelperText:"Required"});
        tempError= true;
      }
      
      if((tempDispatch.dualrearwheel == undefined) ||  (tempDispatch.dualrearwheel.length == 0)){
        this.setState({dualrearwheelError:true});
        this.setState({dualrearwheelHelperText:"Required"});
        tempError= true;
      }
      
    }else{
      
      if((tempDispatch.istruck == "yes")) {
        
        if((tempDispatch.truckloaded == undefined) ||  (tempDispatch.truckloaded.length == 0)){
          this.setState({truckloadedError:true});
          this.setState({truckloadedHelperText:"Required"});
          tempError= true;
          if((tempDispatch.height == undefined) ||  (tempDispatch.height.length == 0)){
            this.setState({heightError:true});
            this.setState({heightHelperText:"Required"});
            tempError= true;
          }
          
          if((tempDispatch.totalweight == undefined) ||  (tempDispatch.totalweight.length == 0)){
            this.setState({totalweightError:true});
            this.setState({totalweightHelperText:"Required"});
            tempError= true;
          }
          
          if((tempDispatch.dualrearwheel == undefined) ||  (tempDispatch.dualrearwheel.length == 0)){
            this.setState({dualrearwheelError:true});
            this.setState({dualrearwheelHelperText:"Required"});
            tempError= true;
          }
        }else{
          
          if((tempDispatch.truckloaded == "yes")) {
            
            if((tempDispatch.height == undefined) ||  (tempDispatch.height.length == 0)){
              this.setState({heightError:true});
              this.setState({heightHelperText:"Required"});
              tempError= true;
            }
            
            if((tempDispatch.totalweight == undefined) ||  (tempDispatch.totalweight.length == 0)){
              this.setState({totalweightError:true});
              this.setState({totalweightHelperText:"Required"});
              tempError= true;
            }
            
            if((tempDispatch.dualrearwheel == undefined) ||  (tempDispatch.dualrearwheel.length == 0)){
              this.setState({dualrearwheelError:true});
              this.setState({dualrearwheelHelperText:"Required"});
              tempError= true;
            }
            
          }
        }
      }
      
    }//end of else for istruck
    
    
    
    
    if((tempDispatch.istrailer == undefined) ||  (tempDispatch.istrailer.length == 0)){
      this.setState({istrailerError:true});
      this.setState({istrailerHelperText:"Required"});
      tempError= true;
      
      if ((tempDispatch.hookuptype == undefined) || (tempDispatch.hookuptype.length == 0)) {
        this.setState({hookuptypeError: true});
        this.setState({hookuptypeHelperText: "Required"});
        tempError = true;
      }
      
      if ((tempDispatch.ballsize == undefined) || (tempDispatch.ballsize.length == 0)) {
        this.setState({ballsizeError: true});
        this.setState({ballsizeHelperText: "Required"});
        tempError = true;
      }
    }else{
      if((tempDispatch.istrailer == "yes")) {
        if ((tempDispatch.hookuptype == undefined) || (tempDispatch.hookuptype.length == 0)) {
          this.setState({hookuptypeError: true});
          this.setState({hookuptypeHelperText: "Required"});
          tempError = true;
        }
        
        if ((tempDispatch.ballsize == undefined) || (tempDispatch.ballsize.length == 0)) {
          this.setState({ballsizeError: true});
          this.setState({ballsizeHelperText: "Required"});
          tempError = true;
        }
      }
    }
    
    
    
    
    if((tempDispatch.calltype == undefined) ||  (tempDispatch.calltype.length == 0)){
      this.setState({calltypeError:true});
      this.setState({calltypeHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.towreason == undefined) ||  (tempDispatch.towreason.length == 0)){
      this.setState({towreasonError:true});
      this.setState({towreasonHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.safelocation == undefined) ||  (tempDispatch.safelocation.length == 0)){
      this.setState({safelocationError:true});
      this.setState({safelocationHelperText:"Required"});
      tempError= true;
    }
    
    
    if((tempDispatch.destination == undefined) ||  (tempDispatch.destination.length == 0)){
      this.setState({destinationError:true});
      this.setState({destinationHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.damage == undefined) ||  (tempDispatch.damage.length == 0)){
      this.setState({damageError:true});
      this.setState({damageHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.attended == undefined) ||  (tempDispatch.attended.length == 0)){
      this.setState({attendedError:true});
      this.setState({attendedHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.ispo == undefined) ||  (tempDispatch.ispo.length == 0)){
      this.setState({ispoError:true});
      this.setState({ispoHelperText:"Required"});
      tempError= true;
    }
    
    if(tempDispatch.attended == "no") {
      if ((tempDispatch.keylocation == undefined) || (tempDispatch.keylocation.length == 0)) {
        this.setState({keylocationError: true});
        this.setState({keylocationHelperText: "Required"});
        tempError = true;
      }
    }
    
    
    
    
    if((tempDispatch.contact == undefined) ||  (tempDispatch.contact.length == 0)){
      this.setState({contactError:true});
      this.setState({contactHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.requestedby == undefined) ||  (tempDispatch.requestedby.length == 0)){
      this.setState({requestedbyError:true});
      this.setState({requestedbyHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.amountquoted == undefined) ||  (tempDispatch.amountquoted.length == 0)){
      this.setState({amountquotedError:true});
      this.setState({amountquotedHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.paymentmethod == undefined) ||  (tempDispatch.paymentmethod.length == 0)){
      this.setState({paymentmethodError:true});
      this.setState({paymentmethodHelperText:"Required"});
      tempError= true;
    }
    
    
    
    if(this.state.dispatch.paymentmethod == "Charge Account"){
      
      if((tempDispatch.billto == undefined) ||  (tempDispatch.billto.length == 0)){
        this.setState({billtoError:true});
        this.setState({billtoHelperText:"Required"});
        tempError= true;
      }
    }
    
    if(tempDispatch.ispo == "yes") {
      if ((tempDispatch.ponumber == undefined) || (tempDispatch.ponumber.length == 0)) {
        this.setState({ponumberError: true});
        this.setState({ponumberHelperText: "Required"});
        tempError = true;
      }
      
      if ((tempDispatch.policynumber == undefined) || (tempDispatch.policynumber.length == 0)) {
        this.setState({policynumberError: true});
        this.setState({policynumberHelperText: "Required"});
        tempError = true;
      }
    }
    
    if((tempDispatch.overageamount == undefined) ||  (tempDispatch.overageamount.length == 0)){
      this.setState({overageamountError:true});
      this.setState({overageamountHelperText:"Required"});
      tempError= true;
    }
    
    
    if((tempDispatch.claimnumber == undefined) ||  (tempDispatch.claimnumber.length == 0)){
      this.setState({claimnumberError:true});
      this.setState({claimnumberHelperText:"Required"});
      tempError= true;
    }
    
    if((this.state.selectedDriver == undefined) ||  (this.state.selectedDriver.length == 0)){
      this.setState({driverError:true});
      this.setState({driverHelperText:"Required"});
      tempError= true;
    }
    
    if((this.state.selectedTruck == undefined) ||  (this.state.selectedTruck.length == 0)){
      this.setState({trucknumberError:true});
      this.setState({trucknumberHelperText:"Required"});
      tempError= true;
    }
    
    if((tempDispatch.dispatchedby == undefined) ||  (tempDispatch.dispatchedby.length == 0)){
      this.setState({dispatchedbyError:true});
      this.setState({dispatchedbyHelperText:"Required"});
      tempError= true;
    }
    
    
    if((tempDispatch.dispatchdate == undefined) ||  (tempDispatch.dispatchdate == null)){
      this.setState({dispatchdateError:true});
      this.setState({dispatchdateHelperText:"Required"});
      tempError= true;
    }
    
    /* if((tempDispatch.dispatchtime == undefined) ||  (tempDispatch.dispatchtime == null)){
				 this.setState({dispatchtimeError:true});
				 this.setState({dispatchtimeHelperText:"Required"});
				 tempError= true;
		 }*/
    
    if((tempDispatch.servicetype == undefined) ||  (tempDispatch.servicetype.length == 0)){
      this.setState({servicetypeError:true});
      this.setState({servicetypeHelperText:"Required"});
      tempError= true;
    }
    
    
    
    
    if((tempDispatch.policeid == undefined) ||  (tempDispatch.policeid == null)){
      this.setState({selectedPoliceError:true});
      this.setState({selectedPoliceHelperText:"Required"});
      tempError= true;
    }
    
    
    
    if(tempError){
      this.handleClickOpen();
      return;
    }else{
    }
    
    
    
    var tempPlate = this.state.dispatch.plate.toUpperCase();
    tempPlate=tempPlate.trim();
    tempPlate=tempPlate.replace(/\s+/g, '');
    tempDispatch.plate= tempPlate;
    
    var tempVin=this.state.dispatch.vin.toUpperCase();
    tempVin=tempVin.trim();
    tempVin=tempVin.replace(/\s+/g, '');
    tempDispatch.vin= tempVin;
    
    
    //tempStream.locationId= this.state.selectedLocation.id;
    //this.state.selectedCompany.id
    saveADispatchsheet(DEFAULT_VESPAAN_SERVER.url,  tempDispatch, this.props.selectedCompany);
    if((tempDispatch.id != null)  && (tempDispatch.id != undefined)) {
      updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany, tempDispatch.id);
    }else{
      if((this.props.saveDispatchsheetResponse != null)  && (this.props.saveDispatchsheetResponse != undefined)) {
        updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany, this.props.saveDispatchsheetResponse.id);
      }
    }
    //we don't need teh refresh here. The websocket will take care of it.
    //this.refresh();
    
    
  };
  
  
  
  /*static getDerivedStateFromProps(props, state) {
			if (props.passedDispatchLog !== state.dispatch) {
					console.log("I am return not null");
					return {
							dispatch: props.passedDispatchLog,
					};
			}

			// Return null if the state hasn't changed
			console.log("I am return null");
			return null;
	}*/
  
  handleClickOpen () {
    this.setState({open:true});
  };
  
  
  componentDidUpdate(prevProps, prevState) {
    /*if (this.props.passedDispatchLog !== prevProps.passedDispatchLog) {
				this.setState({dispatch:this.props.passedDispatchLog });
		}*/
    if(this.state.clearFields == false) {
      if (this.state.dispatch != this.props.passedDispatchLog) {
        this.setState({dispatch: this.props.passedDispatchLog});
      }
    }
  }
  
  handleClose () {
    this.setState({open:false});
  };
  
  
  
  handleUpdate () {
    let { updateAUser } = this.props;
    
    var tempStream = this.state.selectedUser ;
    tempStream.id=this.props.UserSaveResponse.id;
    tempStream.username=" ";
    tempStream.password=" ";
    tempStream.usertype="1";
    if((tempStream.address2 == null) ||(tempStream.address2.length == 0)){
      tempStream.address2="  ";
    }
    updateAUser(DEFAULT_VESPAAN_SERVER.url,  tempStream);
    
  };
  
  handlePhoneChange(event) {
    //event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ phoneHelperText: '', phoneError: false });
      
    } else {
      this.setState({ phoneHelperText: 'Required', phoneError: true });
    }
    this.setState(Object.assign(this.state.selectedUser,{phone:event.target.value}));
  }
  
  handleEmailChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{email:event.target.value}));
  }
  handleZipcodeChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{zipcode:event.target.value}));
  }
  /*handleCountryChange(event) {
			//event.preventDefault();
			this.setState(Object.assign(this.state.selectedUser,{country:event.target.value}));
	}

	handleStateChange(event) {
			//event.preventDefault();
			this.setState(Object.assign(this.state.selectedUser,{state:event.target.value}));
	}*/
  
  
  handleCityChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{city:event.target.value}));
  }
  
  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }
  
  handleAddress1Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address1:event.target.value}));
  }
  
  handleFirstnameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{firstName:event.target.value}));
  }
  
  
  handleLastnameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{lastName:event.target.value}));
  }
  
  
  
  
  
  clearFields = (e) => {
    e.preventDefault();
    this.setState(state => ({
      inputFieldShrinkState:true
    }));
    
    
    var tempSelectedUser =   Object.assign({}, this.state.dispatch);
    Object.keys(tempSelectedUser).map((key, index) => {
      tempSelectedUser[key] = "" ;
    });
    this.setState({clearFields:true});
    this.setState({dispatch:tempSelectedUser});
  };
  
  
  
  renderErrorFiled(data){
  
  
  }
  
  /*refresh(event) {
			let { loadUsersData } = this.props;
			loadUsersData(DEFAULT_VESPAAN_SERVER.url );
	}*/
  
  refresh(){
    let { loadDispatchsheetsData } = this.props;
    loadDispatchsheetsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompany.id );
    
    this.setState({
      errorCMsg:{}
    });
  }
  
  
  // saveUserResp
  
  
  /* getListOfUsers() {

			 if(this.props.UserSaveResponse != null){

							 return(<CardUserInformation info={this.props.UserSaveResponse}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardUserInformation> );
			 }else{
					 return(<p> No User yet!</p>)
			 }
	 }*/
  
  /*getListOfUsers() {
			let tempArray = this.props.usersArray;
			let returnArray=[];
			if (tempArray) {
					returnArray = tempArray.map((s) => {
							return(<CardUserInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardUserInformation> );
					});
			}
			return(returnArray);
	}
	*/
  
  handleClickShowSavedDispatch() {
    this.setState({showDispatchSavedDialog:true});
  };
  
  
  handleClickShowSavedDispatchClose() {
    let {clearDispatchErrorMsg} = this.props;
    this.setState({showDispatchSavedDialog:false});
    clearDispatchErrorMsg();
  };
  
  
  handleCallDateChangeK(event) {
    /*if ((event != null)  && (event != undefined) ){
				this.setState({ callDateHelperText: '', callDateError: false });

		} else {
				this.setState({ callDateHelperText: 'Required', callDateError: true });
		}*/
    this.setState({callDateK:event});
  }
  
  handleCallDateChange(event) {
    if ((event != null)  && (event != undefined) ){
      this.setState({ callDateHelperText: '', callDateError: false });
      
    } else {
      this.setState({ callDateHelperText: 'Required', callDateError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{callDate:event}));
  }
  
  /* handleCallTimeChange(event) {
			if ((event != null)  && (event != undefined) ){
					this.setState({ calltimeHelperText: '', calltimeError: false });

			} else {
					this.setState({ calltimeHelperText: 'Required', calltimeError: true });
			}
			this.setState(Object.assign(this.state.dispatch,{calltime:event}));
	}*/
  
  handleETATimeChange(event) {
    if ((event != null)  && (event != undefined) ){
      this.setState({ etaDateHelperText: '', etaDateError: false });
      
    } else {
      this.setState({ etaDateHelperText: 'Required', etaDateError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{etaDate:event}));
  }
  
  handleReceivedByChange(event) {
    //event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ receivedbyHelperText: '', receivedbyError: false });
      
    } else {
      this.setState({ receivedbyHelperText: 'Required', receivedbyError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{receivedby:event.target.value}));
  }
  
  handleNameChange(event) {
    //event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ nameHelperText: '', nameError: false });
      
    } else {
      this.setState({ nameHelperText: 'Required', nameError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{name:event.target.value}));
  }
  
  handleCallBackNumberChange(event) {
    //event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ callbacknumberHelperText: '', callbacknumberError: false });
      
    } else {
      this.setState({ callbacknumberHelperText: 'Required', callbacknumberError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{callbacknumber:event.target.value}));
  }
  
  handleLocationChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ locationHelperText: '', locationError: false });
      
    } else {
      this.setState({ locationHelperText: 'Required', locationError: true });
    }
    
    
    this.setState(Object.assign(this.state.dispatch,{location:event.target.value}));
  }
  
  handleTownChange(event) {
    
    if (event.target.value.length > 0) {
      this.setState({ townHelperText: '', townError: false });
      
    } else {
      this.setState({ townHelperText: 'Required', townError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{town:event.target.value}));
  }
  
  
  handleBodyChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ bodyHelperText: '', bodyError: false });
      
    } else {
      this.setState({ bodyHelperText: 'Required', bodyError: true });
    }
    //this.setState(Object.assign(this.state.dispatch,{body:event.target.value}));
    this.setState(Object.assign(this.props.decodedVinVehicleObject,{body:event.target.value}));
  }
  
  
  handleTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ typeHelperText: '', typeError: false });
      
    } else {
      this.setState({ typeHelperText: 'Required', typeError: true });
    }
    //this.setState(Object.assign(this.state.dispatch,{type:event.target.value}));
    this.setState(Object.assign(this.props.decodedVinVehicleObject,{type:event.target.value}));
  }
  
  
  handleVinChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ vinHelperText: '', vinError: false });
      
    } else {
      this.setState({ vinHelperText: 'Required',vinError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{vin:event.target.value}));
  }
  
  
  handleYearChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ yearHelperText: '', yearError: false });
      
    } else {
      this.setState({ yearHelperText: 'Required', yearError: true });
    }
    //this.setState(Object.assign(this.state.dispatch,{year:event.target.value}));
    this.setState(Object.assign(this.props.decodedVinVehicleObject,{year:event.target.value}));
  }
  
  
  handleMakeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ makeHelperText: '', makeError: false });
      
    } else {
      this.setState({ makeHelperText: 'Required', makeError: true });
    }
    //this.setState(Object.assign(this.state.dispatch,{make:event.target.value}));
    this.setState(Object.assign(this.props.decodedVinVehicleObject,{make:event.target.value}));
  }
  
  handleModelChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ modelHelperText: '', modelError: false });
      
    } else {
      this.setState({ modelHelperText: 'Required', modelError: true });
    }
    //this.setState(Object.assign(this.state.dispatch,{model:event.target.value}));
    this.setState(Object.assign(this.props.decodedVinVehicleObject,{model:event.target.value}));
  }
  
  handleColorChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ colorHelperText: '', colorError: false });
      
    } else {
      this.setState({ colorHelperText: 'Required', colorError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{color:event.target.value}));
  }
  
  
  handlePlateChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ plateHelperText: '', plateError: false });
      
    } else {
      this.setState({ plateHelperText: 'Required', plateError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{plate:event.target.value}));
  }
  
  
  
  
  
  handleStateChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ stateHelperText: '', stateError: false });
      
    } else {
      this.setState({ stateHelperText: 'Required', stateError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{state:event.target.value}));
    this.setState({selectedVehicleState:event.target.value});
  }
  
  handleCountryChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ countryHelperText: '', countryError: false });
      
    } else {
      this.setState({ countryHelperText: 'Required', countryError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{country:event.target.value}));
    this.setState({selectedVehicleCountry:event.target.value});
  }
  
  
  handleUnitsizeChange(event) {
    
    if (event.target.value.length > 0) {
      this.setState({ unitsizeHelperText: '', unitsizeError: false });
      
    } else {
      this.setState({ unitsizeHelperText: 'Required', unitsizeError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{unitsize:event.target.value}));
  }
  handleUnitnumberChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ unitnumberHelperText: '', unitnumberError: false });
      
    } else {
      this.setState({ unitnumberHelperText: 'Required', unitnumberError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{unitnumber:event.target.value}));
  }
  handleOtherChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ otherHelperText: '', otherError: false });
      
    } else {
      this.setState({ otherHelperText: 'Required', otherError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{other:event.target.value}));
  }
  
  handleVehicleTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ vehicletypeHelperText: '', vehicletypeError: false });
      
    } else {
      this.setState({ vehicletypeHelperText: 'Required', vehicletypeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{vehicletype:event.target.value}));
  }
  
  handleDriveTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ drivetypeHelperText: '', drivetypeError: false });
      
    } else {
      this.setState({ drivetypeHelperText: 'Required', drivetypeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{drivetype:event.target.value}));
  }
  
  handleHubTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ lockouthubHelperText: '', lockouthubError: false });
      
    } else {
      this.setState({ lockouthubHelperText: 'Required', lockouthubError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{lockouthub:event.target.value}));
  }
  
  handlePassengersChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ passengersHelperText: '', passengersError: false });
      
    } else {
      this.setState({ passengersHelperText: 'Required', passengersError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{passengers:event.target.value}));
  }
  
  handleTruckLoadedChange(event) {
    
    if (event.target.value.length > 0) {
      this.setState({ truckloadedHelperText: '', truckloadedError: false });
      
    } else {
      this.setState({ truckloadedHelperText: 'Required', truckloadedError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{truckloaded:event.target.value}));
  }
  
  handleHeightChange(event) {
    
    if (event.target.value.length > 0) {
      this.setState({ heightHelperText: '', heightError: false });
      
    } else {
      this.setState({ heightHelperText: 'Required', heightError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{height:event.target.value}));
  }
  
  handleTotalWeightChange(event) {
    if( this.state.verify == "yes") {
      if (event.target.value.length > 0) {
        this.setState({totalweightHelperText: '', totalweightError: false});
      } else {
        this.setState({totalweightHelperText: 'Required', totalweightError: true});
      }
    }
    this.setState(Object.assign(this.state.dispatch,{totalweight:event.target.value}));
  }
  
  handleDualRearWheelChange(event) {
    
    if (event.target.value.length > 0) {
      this.setState({ dualrearwheelHelperText: '', dualrearwheelError: false });
      
    } else {
      this.setState({ dualrearwheelHelperText: 'Required', dualrearwheelError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{dualrearwheel:event.target.value}));
  }
  
  handleHookupTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ hookuptypeHelperText: '', hookuptypeError: false });
    } else {
      this.setState({ hookuptypeHelperText: 'Required', hookuptypeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{hookuptype:event.target.value}));
  }
  
  handleBallSizeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ ballsizeHelperText: '', ballsizeError: false });
      
    } else {
      this.setState({ ballsizeHelperText: 'Required', ballsizeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{ballsize:event.target.value}));
  }
  
  handleCallTypeChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ calltypeHelperText: '', calltypeError: false });
      
    } else {
      this.setState({ calltypeHelperText: 'Required', calltypeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{calltype:event.target.value}));
  }
  
  handleTowReasonChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ towreasonHelperText: '', towreasonError: false });
      
    } else {
      this.setState({ towreasonHelperText: 'Required', towreasonError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{towreason:event.target.value}));
  }
  
  handleSafeLocationChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ safelocationHelperText: '', safelocationError: false });
      
    } else {
      this.setState({ safelocationHelperText: 'Required', safelocationError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{safelocation:event.target.value}));
  }
  
  handleDestinationChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ destinationHelperText: '', destinationError: false });
      
    } else {
      this.setState({ destinationHelperText: 'Required', destinationError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{destination:event.target.value}));
  }
  
  
  handleVerifyRadioChange(event) {
    this.setState({verify:event.target.value});
    
    if(event.target.value =='no' ){
      
      this.setState({receivedbyHelperText:"",
        receivedbyError:false,
        callDateHelperText:"",
        callDateError:false,
        etaDateHelperText:"",
        etaDateError:false,
        nameHelperText:"",
        nameError:false,
        callbacknumberHelperText:"",
        callbacknumberError:false,
        locationHelperText:"",
        locationError:false,
        townHelperText:"",
        townError:false,
        bodyHelperText:"",
        bodyError:false,
        typeHelperText:"",
        typeError:false,
        vinHelperText:"",
        vindError:false,
        yearHelperText:"",
        yearError:false,
        makeHelperText:"",
        makeError:false,
        modelHelperText:"",
        modelError:false,
        colorHelperText:"",
        colorError:false,
        plateHelperText:"",
        plateError:false,
        stateHelperText:"",
        stateError:false,
        countryHelperText:"",
        countryError:false,
        unitsizeHelperText:"",
        unitsizeError:false,
        unitnumberHelperText:"",
        unitnumberError:false,
        otherHelperText:"",
        otherError:false,
        vehicletypeHelperText:"",
        vehicletypeError:false,
        drivetypeHelperText:"",
        drivetypeError:false,
        lockouthubHelperText:"",
        lockouthubError:false,
        passengersHelperText:"",
        passengersError:false,
        truckloadedHelperText:"",
        truckloadedError:false,
        heightHelperText:"",
        heightError:false,
        totalweightHelperText:"",
        totalweightError:false,
        dualrearwheelHelperText:"",
        dualrearwheelError:false,
        hookuptypeHelperText:"",
        hookuptypeError:false,
        ballsizeHelperText:"",
        ballsizeError:false,
        calltypeHelperText:"",
        calltypeError:false,
        towreasonHelperText:"",
        towreasonError:false,
        safelocationHelperText:"",
        safelocationError:false,
        destinationHelperText:"",
        destinationError:false,
        damageHelperText:"",
        damageError:false,
        attendedHelperText:"",
        attendedError:false,
        ispoHelperText:"",
        ispoError:false,
        keylocationHelperText:"",
        keylocationError:false,
        contactHelperText:"",
        contactError:false,
        requestedbyHelperText:"",
        requestedbyError:false,
        amountquotedHelperText:"",
        amountquotedError:false,
        paymentmethodHelperText:"",
        paymentmethodError:false,
        billtoHelperText:"",
        billtoError:false,
        ponumberHelperText:"",
        ponumberError:false,
        policynumberHelperText:"",
        policynumberError:false,
        overageamountHelperText:"",
        overageamountError:false,
        claimnumberHelperText:"",
        claimnumberError:false,
        commentHelperText:"",
        commentError:false,
        driverHelperText:"",
        driverError:false,
        trucknumberHelperText:"",
        trucknumberError:false,
        dispatchedbyHelperText:"",
        dispatchedbyError:false,
        dispatchdateHelperText:"",
        dispatchdateError:false,
        //dispatchtimeHelperText:"",
        //dispatchtimeError:false,
        servicetypeHelperText:"",
        servicetypeError:false,
        istrailerHelperText:"",
        istrailerError:false,
        istruckHelperText:"",
        istruckError:false,
        filepathHelperText:"",
        filepathError:false,
        selectedPoliceHelperText:"",
        selectedPoliceError:false,});
    }
    
  }
  
  handleDamageChange(event) {
    //event.preventDefault();
    if (event.target.value.length > 0){
      this.setState({ damageHelperText: '', damageError: false });
      
    } else {
      this.setState({ damageHelperText: 'Required', damageError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{damage: event.target.value}));
    //this.damage=event.target.value;
    //event.preventDefault();
  }
  
  /*  old one
	handleDamageChange(event) {
			//event.preventDefault();
			if (event.target.value.length > 0) {
					this.setState({ damageHelperText: '', damageError: false });

			} else {
					this.setState({ damageHelperText: 'Required', damageError: true });
			}
			this.setState(Object.assign(this.state.dispatch,{damage:event.target.value}));
			//this.damage=event.target.value;
			//event.preventDefault();
			 }
					*/
  handleAttendedChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ attendedHelperText: '', attendedError: false });
      
    } else {
      this.setState({ attendedHelperText: 'Required', attendedError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{attended:event.target.value}));
  }
  
  handleIspoChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ ispoHelperText: '', ispoError: false });
      
    } else {
      this.setState({ ispoHelperText: 'Required', ispoError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{ispo:event.target.value}));
  }
  
  handleKeyLocationChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ keylocationHelperText: '', keylocationError: false });
      
    } else {
      this.setState({ keylocationHelperText: 'Required', keylocationError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{keylocation:event.target.value}));
  }
  
  
  handleContactChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ contactHelperText: '', contactError: false });
      
    } else {
      this.setState({ contactHelperText: 'Required', contactError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{contact:event.target.value}));
  }
  
  handleRequestedbyChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ requestedbyHelperText: '', requestedbyError: false });
      
    } else {
      this.setState({ requestedbyHelperText: 'Required', requestedbyError: true });
    }
    
    this.setState(Object.assign(this.state.dispatch,{requestedby:event.target.value}));
  }
  
  handleAmountquotedChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ amountquotedHelperText: '', amountquotedError: false });
      
    } else {
      this.setState({ amountquotedHelperText: 'Required', amountquotedError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{amountquoted:event.target.value}));
  }
  
  handlePaymentMethodChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ paymentmethodHelperText: '', paymentmethodError: false });
      
    } else {
      this.setState({ paymentmethodHelperText: 'Required', paymentmethodError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{paymentmethod:event.target.value}));
  }
  
  handleBilltoChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ billtoHelperText: '', billtoError: false });
      
    } else {
      this.setState({ billtoHelperText: 'Required', billtoError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{billto:event.target.value}));
  }
  
  handlePONumberChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ ponumberHelperText: '', ponumberError: false });
      
    } else {
      this.setState({ ponumberHelperText: 'Required', ponumberError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{ponumber:event.target.value}));
  }
  
  handlePolicyNumberChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ policynumberHelperText: '', policynumberError: false });
      
    } else {
      this.setState({ policynumberHelperText: 'Required', policynumberError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{policynumber:event.target.value}));
  }
  
  handleOverageamountChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ overageamountHelperText: '', overageamountError: false });
      
    } else {
      this.setState({ overageamountHelperText: 'Required', overageamountError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{overageamount:event.target.value}));
  }
  
  handleClaimNumberChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ claimnumberHelperText: '', claimnumberError: false });
      
    } else {
      this.setState({ claimnumberHelperText: 'Claim Number Required', claimnumberError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{claimnumber:event.target.value}));
  }
  
  handleCommentChange(event) {
    
    
    this.setState(Object.assign(this.state.dispatch,{comment:event.target.value}));
  }
  
  
  handleDriverChange(event) {
    if ((event.target.value != null)  || (event.target.value != undefined)){
      this.setState({ driverHelperText: '', driverError: false });
      
    } else {
      this.setState({ driverHelperText: 'Required', driverError: true });
    }
    this.setState({selectedDriver:event.target.value});
  }
  
  handleTrucknumberChange(event) {
    if ((event.target.value != null)  || (event.target.value != undefined)){
      this.setState({ trucknumberHelperText: '', trucknumberError: false });
      
    } else {
      this.setState({ trucknumberHelperText: 'Required', trucknumberError: true });
    }
    this.setState({selectedTruck:event.target.value});
  }
  
  handlePoliceChange(event) {
    if ((event.target.value != null)  || (event.target.value != undefined)){
      this.setState({ selectedPoliceHelperText: '', selectedPoliceError: false });
      
    } else {
      this.setState({ selectedPoliceHelperText: 'Required', selectedPoliceError: true });
    }
    this.setState({selectedPolice:event.target.value});
  }
  
  handleDispatchbyChange(event) {
    if (event.target.value.length > 0) {
      this.setState({ dispatchedbyHelperText: '', dispatchedbyError: false });
      
    } else {
      this.setState({ dispatchedbyHelperText: 'Required', dispatchedbyError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{dispatchedby:event.target.value}));
  }
  
  
  handleDispatchDateChange(event) {
    //event.preventDefault();
    if ((event != null) && (event != undefined)) {
      this.setState({ dispatchdateHelperText: '', dispatchdateError: false });
      
    } else {
      this.setState({ dispatchdateHelperText: 'Required', dispatchdateError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{dispatchdate:event}));
  }
  
  /* handleDispatchTimeChange(event) {
			 if ((event != null) && (event != undefined)) {
					 this.setState({ dispatchtimeHelperText: '', dispatchtimeError: false });

			 } else {
					 this.setState({ dispatchtimeHelperText: 'Required', dispatchtimeError: true });
			 }
			 this.setState(Object.assign(this.state.dispatch,{dispatchtime:event}));
	 }*/
  
  handleServiceTypeChange(event) {
    event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ servicetypeHelperText: '', servicetypeError: false });
      
    } else {
      this.setState({ servicetypeHelperText: 'Required', servicetypeError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{servicetype:event.target.value}));
  }
  
  handleIsTrailerChange(event) {
    event.preventDefault();
    if (event.target.value.length > 0) {
      this.setState({ istrailerHelperText: '', istrailerError: false });
      
    } else {
      this.setState({ istrailerHelperText: 'Required', istrailerError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{istrailer:event.target.value}));
  }
  
  handleIsTruckChange(event) {
    event.preventDefault();
    
    //this.isTruckRef.current= event;
    
    //this.setState({ value: this.isTruckRef.current.value });
    
    if (event.target.value.length > 0) {
      this.setState({ istruckHelperText: '', istruckError: false });
      
    } else {
      this.setState({ istruckHelperText: 'Required', istruckError: true });
    }
    this.setState(Object.assign(this.state.dispatch,{istruck:event.target.value}));
    /* if (this.isTruckRef.current != undefined) {
				this.setState(Object.assign(this.state.dispatch, {istruck: this.isTruckRef.current.value}));
		}*/
  }
  
  
  
  
  
  handleClickShowDispatchLog() {
    this.setState({showFormDialog:true});
  };
  
  
  getPoliceInfoFromPoliceId(argPoliceId){
    var returnPolice = null;
    for(var i = 0; i< this.props.policeArray.length; i++){
      if(this.props.policeArray[i].id == argPoliceId){
        returnPolice =  this.props.policeArray[i];
        break;
      }
    }//for
    return returnPolice;
    
  }
  
  getDriverInfoFromDriverId(argDriverId){
    var returnDriver = null;
    for(var i = 0; i< this.props.towcompanydriversArray.length; i++){
      if(this.props.towcompanydriversArray[i].id == argDriverId){
        returnDriver =  this.props.towcompanydriversArray[i];
        break;
      }
    }//for
    return returnDriver;
    
  }
  
  
  getTruckInfoFromDriverId(argTruckId){
    var returnTruck = null;
    for(var i = 0; i< this.props.towcompanytrucksArray.length; i++){
      if(this.props.towcompanytrucksArray[i].id == argTruckId){
        returnTruck =  this.props.towcompanytrucksArray[i];
        break;
      }
    }//for
    return returnTruck;
  }
  
  getCompanyInfoFromCompanyId(argPoliceId){
    var returnCompany = null;
    for(var i = 0; i< this.props.companysArray.length; i++){
      if(this.props.companysArray[i].id == argPoliceId){
        returnCompany =  this.props.companysArray[i];
        break;
      }
    }//for
    return returnCompany;
    
  }
  
  
  getListOfCompaniesForSelection() {
    let tempArray = this.props.companysArray;
    let returnArray=[];
    let tempReturnArray=[];
    let finalReturnArray=[];
    if (tempArray) {
      
      
      returnArray = tempArray.map((s) => {
        return(<MenuItem key={s.id} value={s}>{s.name}</MenuItem>);
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
      
      
    }
    
    
    return(returnArray);
  }
  
  handleCompanyChange(event) {
    let { loadPoliceData,  updateADispatchsheetPath, selectACompany,loadTowCompanyDriversData,loadTowCompanyTrucksData } = this.props;
    //event.preventDefault();
    this.setState({selectedCompany:event.target.value});
    loadPoliceData(DEFAULT_VESPAAN_SERVER.url,event.target.value.id );
    loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
    loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
    //loadStoragelotsData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
    //loadCompanypropertysData(DEFAULT_VESPAAN_SERVER.url, event.target.value.id);
    //selectACompany(event.target.value.id);
    this.props.changecompany(event.target.value.id);
    //updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url,this.state.selectedCompany.id, "da16da37-e7ce-4107-a7e6-1bcf2f234477");
    if((this.state.dispatch.id != null)  && (this.state.dispatch.id != undefined)) {
      updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url, event.target.value.id, this.state.dispatch.id);
    }else{
      if((this.props.saveDispatchsheetResponse != null)  && (this.props.saveDispatchsheetResponse != undefined)) {
        updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url, event.target.value.id, this.props.saveDispatchsheetResponse.id);
      }
    }
    //this.props.changecompany(event.target.value.id);
    
  }
  
  getListOfPoliceDepartmentsForSelection() {
    let tempArray = this.props.policeArray;
    let returnArray=[];
    if (tempArray) {
      returnArray = tempArray.map((s) => {
        return(<MenuItem key={s.id} value={s}>{s.departmentname}</MenuItem>);
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
    }
    //returnArray.push(<MenuItem key={"Other"} value={{ 'address2':'','address1':'', 'city':'', 'zipcode':'', 'name':'Other'}}> Other</MenuItem>);
    return(returnArray);
  }
  
  getListOfDriversForSelection() {
    let tempArray = this.props.towcompanydriversArray;
    let returnArray=[];
    if (tempArray) {
      returnArray = tempArray.map((s) => {
        return(<MenuItem key={s.id} value={s}>{s.lastname}</MenuItem>);
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
    }
    //returnArray.push(<MenuItem key={"Other"} value={{ 'address2':'','address1':'', 'city':'', 'zipcode':'', 'name':'Other'}}> Other</MenuItem>);
    return(returnArray);
  }
  
  
  
  
  /*
  getListOfDriversForSelection() {
    let tempArray = this.props.towcompanydriversArray;
    let returnArray=[];
    if (tempArray) {
      returnArray = tempArray.map((s) => {
        return({value:{s}, lable: s.lastname  });
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
    }
    //returnArray.push(<MenuItem key={"Other"} value={{ 'address2':'','address1':'', 'city':'', 'zipcode':'', 'name':'Other'}}> Other</MenuItem>);
    return(returnArray);
  }*/
  
  
  
  
  
  getListOfTrucksForSelection() {
    let tempArray = this.props.towcompanytrucksArray;
    let returnArray=[];
    if (tempArray) {
      returnArray = tempArray.map((s) => {
        return(<MenuItem key={s.id} value={s}>{s.truckid}  {s.type}</MenuItem>);
        //return(<CardCompanyInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardCompanyInformation> );
      });
    }
    //returnArray.push(<MenuItem key={"Other"} value={{ 'address2':'','address1':'', 'city':'', 'zipcode':'', 'name':'Other'}}> Other</MenuItem>);
    return(returnArray);
  }
  
  reformatDate(argDate) {
    if ((argDate != null) && (argDate != undefined)) {
      if (argDate.indexOf("T") == -1) {
        return argDate;
      } else {
        var res = argDate.replace("T", " ");
        var n = res.lastIndexOf(".");
        var res2 = res.substring(0, n);
        return res2;
      }
    }
    
  }
  
  hadleLoadedFile(argE, argFileName){
    const {uploadATowPicture} = this.props;
    
    //blob = fileReader.result;
    //new Blob([content], { type: "text/xml"});
    var blob = new Blob([argE.target.result]); //argE.target.result;
    var formData = new FormData();
    // It is of paramount importance for these to have the same name (the first paramater - here 'images')else multer will give you a very cryptic error
    formData.append("content", blob);
    //formData.append("images", img2);
    // you can of course append anything else you'd like
    formData.append("Description", "this is a test file from dispatch");
    formData.append("FileType", argFileName.type);
    formData.append("CompanyId", this.props.selectedCompanyInHere);
    formData.append("Vin", this.state.dispatch.vin.toUpperCase());
    formData.append("TowId", this.state.dispatch.id);
    formData.append("FileName", argFileName.name);
    
    uploadATowPicture(DEFAULT_VESPAAN_SERVER.url,formData ,this.state.selectedCompany.id );
    
  }
  
  
  handleUploadSelectedFile(file){
    const {uploadATowPicture} = this.props;
    //var blob="";
    const fileReader = new FileReader();
    //const name = target.accept.includes('image') ? 'images' : 'videos';
    var tempFile = this.state.chosenfile;
    //fileReader.readAsDataURL(event.target.value);
    fileReader.readAsArrayBuffer(file); //readAsBinaryString(file);//
    fileReader.onload =(e)=>{this.hadleLoadedFile(e, file)};
  };
  
  render() {
    const {classes} = this.props;
    let usStates = MainConstants.getUSStates();
    let canStates = MainConstants.getCanadaStates();
    let availableCountries = MainConstants.getCountries();
    
    /*if((this.props.passedDispatchLog != undefined) && (this.isTruckRef.current != undefined)){
				this.isTruckRef.current.value = this.props.passedDispatchLog.istruck;
		}*/
    //let userCardList = this.getListOfUsers();
    this.companySelectList = this.getListOfCompaniesForSelection();
    this.policeSelectList = this.getListOfPoliceDepartmentsForSelection();
    this.driversSelectList = this.getListOfDriversForSelection();
    this.trucksSelectList = this.getListOfTrucksForSelection();
    var statusText = "Unknown";
    if((this.state.dispatch.status!= null) && (this.state.dispatch.status != undefined)){
      statusText =this.state.dispatch.status;
    }
    return (
      <form>
        <React.Fragment>
          <Typography variant="h6" gutterBottom  align="center">
            Dispatch Log Information for {this.state.dispatch.dispatchnumber}
          </Typography>
          <Grid container spacing={24}   >
            
            <Grid item xs={12} sm={12}>
              {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
              <Grid container >
                
                
                
                <Grid container   spacing={24}  style={{paddingLeft:10}}>
                  <Grid item xs={3} sm={3}>
                    <TextField required id="receivedby" name="receivedby" error={this.state.receivedbyError} helperText={this.state.receivedbyHelperText}  label="Call Received By"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.receivedby} onChange={this.handleReceivedByChange}/>
                  </Grid>
                  
                  {/*
                    <Grid item xs={3} sm={3} >
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker
                            variant="inline"
                            ampm={false}
                            label="With keyboard"
                        value={this.state.callDateK}
                        onChange={this.handleCallDateChangeK}
                        label="Keyboard with error handler"
                        format="fullDateTime24h"
                            />
                            </MuiPickersUtilsProvider>
                    </Grid>*/}
                  
                  
                  
                  <Grid item xs={3} sm={3} >
                    {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker
                        value={this.state.dispatch.callDate}
                        onChange={this.handleCallDateChange}
                        label="Date of Call"
                        onError={console.log}
                        minDate={new Date("2018-01-01T00:00")}
                        format="yyyy/MM/dd hh:mm a"
                            />
                            </MuiPickersUtilsProvider>  */}
                    {/*
                        <Typography variant="body2" >Date of Call</Typography>
                        <DatePickerB
                        selected={this.reformatDate(this.state.dispatch.callDate)}
                        onChange={date => this.handleCallDateChange(date)}
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="time"
                        dateFormat="yyyy-MM-dd HH:mm:ss"
                            /> */}
                    
                    
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      
                      <KeyboardDateTimePicker
                        value={this.state.dispatch.callDate}
                        onChange={this.handleCallDateChange}
                        label="Date of Call"
                        //onError={this.state.callDateError}
                        error={this.state.callDateError}
                        helperText={this.state.callDateHelperText}
                        format="yyyy/MM/dd hh:mm a" />
                      {/*
                            <DatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        label="Date of Call"
                        format="MM/dd/yyyy"
                        value={this.state.dispatch.callDate}
                        onChange={this.handleCallDateChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                        }}
                        required
                        error={this.state.callDateError}
                        helperText={this.state.callDateHelperText} /> */}
                    </MuiPickersUtilsProvider>
                  </Grid>
                  {/*
                    <Grid itemxs={3} sm={3} >
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <TimePicker
                        margin="normal"
                        id="time-picker1"
                        label="Time of Call"
                        value={this.state.dispatch.calltime}
                        onChange={this.handleCallTimeChange}
                        KeyboardButtonProps={{
                            'aria-label': 'change time',
                        }}
                            required
                            error={this.state.calltimeError}
                            helperText={this.state.calltimeHelperText}
                        />
                        </MuiPickersUtilsProvider>
                    </Grid>  */}
                  
                  <Grid itemxs={3} sm={3} >
                    
                    {/*<Typography variant="body2" >E.T.A</Typography>
                    <DatePickerB
                    selected={this.reformatDate(this.state.dispatch.etaDate)}
                    onChange={date => this.handleETATimeChange(date)}
                    showTimeSelect
                    timeIntervals={15}
                    timeCaption="time"
                    dateFormat="yyyy-MM-dd HH:mm:ss "
                        //dateFormat="MMMM d, yyyy h:mm aa"
                        /> */}
                    
                    {/*}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDateTimePicker
                    value={this.state.dispatch.etaDate}
                    onChange={this.handleETATimeChange}
                    label="E.T.A"
                    onError={console.log}
                    minDate={new Date("2018-01-01T00:00")}
                    format="yyyy/MM/dd hh:mm a"
                        />
                        </MuiPickersUtilsProvider>*/}
                    
                    
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      
                      <KeyboardDateTimePicker
                        value={this.state.dispatch.etaDate}
                        onChange={this.handleETATimeChange}
                        label="E.T.A"
                        //onError={this.state.etaDateError}
                        error={this.state.etaDateError}
                        helperText={this.state.etaDateHelperText}
                        
                        format="yyyy/MM/dd hh:mm a"
                      />
                      {/*}
                        <TimePicker
                    margin="normal"
                    id="time-picker2"
                    label="E.T.A"
                    value={this.state.dispatch.etaDate}
                    onChange={this.handleETATimeChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change time',
                    }}
                    required
                    error={this.state.etaDateError}
                    helperText={this.state.etaDateHelperText}
                    />  */}
                    </MuiPickersUtilsProvider>
                  
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <FormControl component="fieldset" className={classes.formControl} >
                      <FormLabel component="legend" style={{color:'#c9229c'}}>  Verify Fields?</FormLabel>
                      <RadioGroup  row aria-label="gender" name="Verify"  value={this.state.verify} onChange={this.handleVerifyRadioChange}>
                        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                        <FormControlLabel value="no" control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <Typography variant="button" gutterBottom  style={{color:'blue'}} align="center">
                      Status:
                    </Typography>
                    <Typography variant="subtitle1" gutterBottom style={{color:'#3e0369'}}   align="center">
                      {statusText }
                    </Typography>
                    {/*
                            <Tooltip title="Shows the status, you can not edit this field">
                      <TextField id="status" name="status"    label="Status"  fullWidth  InputProps={{  className:classes.textFieldColor}} InputLabelProps={{ shrink: true }} disabled={false} style={{fontSize:10}} value={ statusText }   variant="outlined"   />
                        </Tooltip>
                        */}
                  </Grid>
                  
                  
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                
                </Grid>
                
                
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="name" name="name" label="Name"   error={this.state.nameError} helperText={this.state.nameHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.name} onChange={this.handleNameChange}  />
                  </Grid>
                  {/*}
                        <Grid item xs={3} sm={3}>
                        <InputMask mask="(999) 999-9999"   value={this.state.selectedUser.phone} onChange={this.handlePhoneChange}>
                          {()=>  <TextField  required id="phone"  name="phone"  label="Mobile Phone"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  /> }
                    
                        </InputMask>
                        </Grid>   */}
                  {/*  value={this.state.dispatch.callbacknumber} onChange={this.handleCallBackNumberChange}  /> */}
                  <Grid item xs={3} sm={3}>
                    <InputMask mask="(999) 999-9999"   value={this.state.dispatch.callbacknumber} onChange={this.handleCallBackNumberChange}>
                      {()=>  <TextField   required id="callback" name="callback" label="Call Back #"  error={this.state.callbacknumberError} helperText={this.state.callbacknumberHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  /> }
                    </InputMask>
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="location" name="location" label="Location" error={this.state.locationError} helperText={this.state.locationHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.location} onChange={this.handleLocationChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="town" name="town" label="Town" error={this.state.townError} helperText={this.state.townHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.town} onChange={this.handleTownChange}  />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  {((this.props.decodedVinVehicleObject.errorCode != 0) && (this.props.decodedVinVehicleObject != undefined) && (this.props.decodedVinVehicleObject.errorCode != undefined)) &&(
                    
                    <Grid item xs={12} sm={12} >
                      <Typography variant="subtitle1" color='secondary' gutterBottom>
                        VIN decoding failed, please check the VIN and try again.  Error:  {this.props.decodedVinVehicleObject.errorText}
                      </Typography>
                    </Grid>  )}
                  
                  {/*
                        {((this.props.decodedVinVehicleObject.errorCode == 0) || (this.props.decodedVinVehicleObject == undefined) || (this.props.decodedVinVehicleObject.errorCode == undefined)) &&(
                        
                        <Grid item xs={1} sm={1} >
                            <Typography variant="subtitle1" gutterBottom>
                    
                        </Typography>
                        </Grid>
                        )}
                        */}
                  
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="vin" name="vin" label="Vin"  error={this.state.vinError} helperText={this.state.vinHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.vin} onChange={this.handleVinChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <Button variant="contained" color="primary" className={classes.decodebutton}   onClick={(event) => this.handleDecodeVin()} >
                      Decode VIN
                    </Button>
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="body" name="body" label="Body"   error={this.state.bodyError} helperText={this.state.bodyHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.props.decodedVinVehicleObject.body} onChange={this.handleBodyChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="type" name="type" label="Type"  error={this.state.typeError} helperText={this.state.typeHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.props.decodedVinVehicleObject.type} onChange={this.handleTypeChange}  />
                  </Grid>
                  {/*}
                    <Grid item xs={2} sm={2}>
                        <TextField  required id="plate" name="plate" label="Plate #"  error={this.state.plateError} helperText={this.state.plateHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.plate} onChange={this.handlePlateChange}  />
                    </Grid>
                
                    <Grid item xs={2} sm={2}>
                        <TextField  required id="state" name="state" label="State"   error={this.state.stateError} helperText={this.state.stateHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.state} onChange={this.handleStateChange}  />
                    </Grid>
                    */}
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="make" name="make" label="Make"  error={this.state.makeError} helperText={this.state.makeHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.props.decodedVinVehicleObject.make} onChange={this.handleMakeChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="model" name="model" label="Model"   error={this.state.modelError} helperText={this.state.modelHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.props.decodedVinVehicleObject.model} onChange={this.handleModelChange}  />
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="year" name="year" label="Year"  error={this.state.yearError} helperText={this.state.yearHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.props.decodedVinVehicleObject.year} onChange={this.handleYearChange}  />
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="color" name="color" label="Color"  error={this.state.colorError} helperText={this.state.colorHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.color} onChange={this.handleColorChange}  />
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="plate" name="plate" label="Plate #"  error={this.state.plateError} helperText={this.state.plateHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.plate} onChange={this.handlePlateChange}  />
                  </Grid>
                  
                  
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  {/*<Grid item xs={3} sm={3}>
                            <TextField  required id="country" name="country" label="Country"   error={this.state.stateError} helperText={this.state.stateHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.country} onChange={this.handleCountryChange}  />
                        </Grid>  */}
                  
                  <Grid item xs={3} sm={3} >
                    {/*<TextField required id="city" name="city" label="City" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedProperty.city} onChange={this.handleCityChange}/>
                                                               */}
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="age-helper">Country</InputLabel>
                      <Select value={this.state.selectedVehicleCountry}
                              onChange={ this.handleCountryChange}
                              inputProps={{
                                name: 'country',
                                id: 'country-helper',
                              }}
                              error={this.state.countryError}
                              helperText={this.state.countryHelperText}
                      >
                        
                        {availableCountries}
                      
                      </Select>
                    </FormControl>
                  </Grid>
                  
                  {/*
                        <Grid item xs={3} sm={3}>
                            <TextField  required id="state" name="state" label="State"   error={this.state.stateError} helperText={this.state.stateHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.state} onChange={this.handleStateChange}  />
                        </Grid> */}
                  
                  <Grid item xs={3} sm={3} >
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="age-helper">State</InputLabel>
                      <Select value={this.state.selectedVehicleState}    onChange={ this.handleStateChange}
                              inputProps={{
                                name: 'state',
                                id: 'state-helper',
                              }}
                              error={this.state.stateError}
                              helperText={this.state.stateHelperText}
                      >
                        
                        {(this.state.selectedVehicleCountry == "U.S.A") &&  (usStates) }
                        { (this.state.selectedVehicleCountry != "U.S.A") && (canStates)}
                      </Select>
                      {/* <FormHelperText>Select a State </FormHelperText> */}
                    </FormControl>
                  </Grid>
                  
                  
                  
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="unitsize" name="unitsize" label="Unit Size"  error={this.state.unitsizeError} helperText={this.state.unitsizeHelperText}   fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.unitsize} onChange={this.handleUnitsizeChange}  />
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="unitnumber" name="unitnumber" label="Unit Number" error={this.state.unitnumberError} helperText={this.state.unitnumberHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.unitnumber} onChange={this.handleUnitnumberChange}  />
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="other" name="other" label="Other" error={this.state.otherError} helperText={this.state.otherHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.other} onChange={this.handleOtherChange}  />
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.vehicletype == "Automatic" ) ||(this.state.dispatch.vehicletype == "Standard" ) )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.vehicletypeError} helperText={this.state.vehicletypeHelperText}>
                        <FormLabel component="legend">Vehicle Type</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.vehicletype} onChange={this.handleVehicleTypeChange}>
                          <FormControlLabel value="Automatic" control={<Radio />} label="Automatic" />
                          <FormControlLabel value="Standard" control={<Radio />} label="Standard" />
                        
                        </RadioGroup>
                      
                      </FormControl>)}
                    { ((this.state.dispatch.vehicletype == undefined )  )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.vehicletypeError} helperText={this.state.vehicletypeHelperText}>
                        <FormLabel component="legend">Vehicle type</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.vehicletype} onChange={this.handleVehicleTypeChange}>
                          <FormControlLabel value="Automatic" control={<Radio />} label="Automatic" />
                          <FormControlLabel value="Standard" control={<Radio />} label="Standard" />
                        
                        </RadioGroup>
                      
                      </FormControl>)}
                    {(this.state.vehicletypeError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.drivetype == "All WD" ) ||(this.state.dispatch.drivetype == "4 WD" ) )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.drivetypeError} helperText={this.state.drivetypeHelperText} >
                        <FormLabel component="legend">Drive Type</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.drivetype} onChange={this.handleDriveTypeChange}>
                          <FormControlLabel value="4 WD" control={<Radio />} label="4 WD" />
                          <FormControlLabel value="All WD" control={<Radio />} label="All WD" />
                        </RadioGroup>
                      </FormControl>)}
                    { (this.state.dispatch.drivetype == undefined )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.drivetypeError} helperText={this.state.drivetypeHelperText} >
                        <FormLabel component="legend">Drive type</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.drivetype} onChange={this.handleDriveTypeChange}>
                          <FormControlLabel value="4 WD" control={<Radio />} label="4 WD" />
                          <FormControlLabel value="All WD" control={<Radio />} label="All WD" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.drivetypeError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.lockouthub == "yes" ) ||(this.state.dispatch.lockouthub == "no" ) )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.lockouthubError} helperText={this.state.lockouthubHelperText} >
                        <FormLabel component="legend">Lockout Hub?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.lockouthub} onChange={this.handleHubTypeChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    { (this.state.dispatch.lockouthub == undefined  )&&(
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.lockouthubError} helperText={this.state.lockouthubHelperText} >
                        <FormLabel component="legend">Lockout Hub ?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.lockouthub} onChange={this.handleHubTypeChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.lockouthubError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="passengers" name="passengers" label="# of Passengers" error={this.state.passengersError} helperText={this.state.passengersHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.passengers} onChange={this.handlePassengersChange}  />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  
                  <Grid item xs={3} sm={3}  >
                    { ((this.state.dispatch.istruck == "yes" ) ||(this.state.dispatch.istruck == "no" ) )&&(
                      <FormControl component="fieldset" className={classes.formControl}  error={this.state.istruckError} helperText={this.state.istruckHelperText} >
                        <FormLabel component="legend">Is A Truck?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender12"   value={this.state.dispatch.istruck}  onChange={this.handleIsTruckChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                        {(this.state.istruckError == true)&&(
                          < Typography   style={{ color:'#f54242'}}
                                         variant = "body2"
                          >Please Select One < /Typography>)
                        }
                      </FormControl>)}
                    
                    { ((this.state.dispatch.istruck == undefined ))&&(
                      <FormControl component="fieldset" className={classes.formControl}  error={this.state.istruckError} helperText={this.state.istruckHelperText} >
                        <FormLabel component="legend">is A Truck?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender12"   value={this.state.dispatch.istruck}  onChange={this.handleIsTruckChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                        {(this.state.istruckError == true)&&(
                          < Typography   style={{ color:'#f54242'}}
                                         variant = "body2"
                          >Please Select One < /Typography>)
                        }
                      </FormControl>)}
                  
                  
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    { (this.state.dispatch.istruck == "yes" ) && (
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.truckloadedError} helperText={this.state.truckloadedHelperText}  >
                        <FormLabel component="legend">Is Truck Loaded?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.truckloaded} onChange={this.handleTruckLoadedChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                        {(this.state.truckloadedError)&&(
                          < Typography   style={{ color:'#f54242'}}
                                         variant = "body2"
                          >Please Select One < /Typography>)
                        }
                      
                      </FormControl>)}
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { (this.state.dispatch.truckloaded == "yes" ) && (this.state.dispatch.istruck == "yes" )&& (
                      <div>
                        <TextField  required id="height" name="height" label="Height" error={this.state.heightError} helperText={this.state.heightHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.height} onChange={this.handleHeightChange}  /> <br/>
                        <TextField  required id="totalweight" name="totalweight" label="Total Weight" error={this.state.totalweightError} helperText={this.state.totalweightHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.totalweight} onChange={this.handleTotalWeightChange}  />
                      </div>
                    )}
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { (this.state.dispatch.truckloaded == "yes" ) && (this.state.dispatch.istruck == "yes" )&& (
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.dualrearwheelError} helperText={this.state.dualrearwheelHelperText}  >
                        <FormLabel component="legend">Dual Rear Wheels?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.dualrearwheel} onChange={this.handleDualRearWheelChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                        {(this.state.dualrearwheelError)&&(
                          < Typography   style={{ color:'#f54242'}}
                                         variant = "body2"
                          >Please Select One < /Typography>)
                        }
                      </FormControl>)}
                  </Grid>
                  {/*
                            <Grid item xs={2} sm={2}>
                                <FormControl component="fieldset" className={classes.formControl}>
                                <FormLabel component="legend">Is Trailer </FormLabel>
                                    <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.istrailer} onChange={this.handleIsTrailerChange}>
                                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                    <FormControlLabel value="no" control={<Radio />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>


                            { (this.state.dispatch.istrailer == "yes") && (
                            <Grid item xs={2} sm={2}>
                                    <FormControl component="fieldset" className={classes.formControl}>
                                    <FormLabel component="legend">Type of Hookup </FormLabel>
                                        <RadioGroup aria-label="gender" name="gender1" row={true} value={this.state.dispatch.hookuptype} onChange={this.handleHookupTypeChange}>
                                    <FormControlLabel value="pintle" control={<Radio />} label="Pintle" />
                                    <FormControlLabel value="5thwheel" control={<Radio />} label="5th Wheel" />
                                    <FormControlLabel value="gooseneck" control={<Radio />} label="Goose Neck" />
                                    </RadioGroup>
                                    </FormControl>
                            </Grid>
                            )}
                                */}
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                </Grid>
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  
                  <Grid item xs={2} sm={2}>
                    { ((this.state.dispatch.istrailer == "yes") || (this.state.dispatch.istrailer == "no")) && (
                      <FormControl required component="fieldset" className={classes.formControl}  error={this.state.istrailerError} helperText={this.state.istrailerHelperText} >
                        <FormLabel component="legend">Is Trailer ? </FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.istrailer} onChange={this.handleIsTrailerChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    { ((this.state.dispatch.istrailer == undefined) ) && (
                      <FormControl required component="fieldset" className={classes.formControl}  error={this.state.istrailerError} helperText={this.state.istrailerHelperText} >
                        <FormLabel component="legend">is Trailer? </FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.istrailer} onChange={this.handleIsTrailerChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.istrailerError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  
                  { (this.state.dispatch.istrailer == "yes") && (
                    <Grid item xs={2} sm={2}>
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.hookuptypeError} helperText={this.state.hookuptypeHelperText}>
                        <FormLabel component="legend">Type of Hookup </FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" row={true} value={this.state.dispatch.hookuptype} onChange={ this.handleHookupTypeChange}>
                          <FormControlLabel value="pintle" control={<Radio />} label="Pintle" />
                          <FormControlLabel value="5thwheel" control={<Radio />} label="5th Wheel" />
                          <FormControlLabel value="gooseneck" control={<Radio />} label="Goose Neck" />
                        </RadioGroup>
                      </FormControl>
                      {(this.state.hookuptypeError)&&(
                        < Typography   style={{ color:'#f54242'}}
                                       variant = "body2"
                        >Please Select One < /Typography>)
                      }
                    </Grid>
                  )}
                  
                  
                  <Grid item xs={2} sm={2}>
                    { (this.state.dispatch.istrailer == "yes") && (
                      <FormControl component="fieldset" className={classes.formControl} error={this.state.ballsizeError} helperText={this.state.ballsizeHelperText} >
                        <FormLabel component="legend">Ball Size</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1"   value={this.state.dispatch.ballsize} onChange={this.handleBallSizeChange}>
                          <FormControlLabel value="1.78" control={<Radio />} label="1 7/8" />
                          <FormControlLabel value="2" control={<Radio />} label="2" />
                          <FormControlLabel value="2.516" control={<Radio />} label="2 5/16" />
                        </RadioGroup>
                        {(this.state.ballsizeError)&&(
                          < Typography   style={{ color:'#f54242'}}
                                         variant = "body2"
                          >Please Select One < /Typography>)
                        }
                      </FormControl>
                    
                    
                    )}
                  </Grid>
                  
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.istrailer == "yes") || (this.state.dispatch.istrailer == "no")) && (
                      <FormControl  component="fieldset" className={classes.formControl}  error={this.state.calltypeError} helperText={this.state.calltypeHelperText} >
                        <FormLabel component="legend">Type Of Call</FormLabel>
                        <RadioGroup aria-label="gender" name="calltype" row={true} value={this.state.dispatch.calltype} onClick={this.handleCallTypeChange}>
                          <FormControlLabel key="HD/MD Tow" value="HD/MD Tow"  control={<Radio />} label="HD/MD Tow" />
                          <FormControlLabel key="LD Tow" value="LD Tow" control={<Radio />} label="LD Tow" />
                          <FormControlLabel key="Flatbed" value="Flatbed" control={<Radio />} label="Flatbed" />
                          <FormControlLabel key="Landoll" value="Landoll" control={<Radio />} label="Landoll" />
                          <FormControlLabel key="Container Trailer" value="Container Trailer" control={<Radio />} label="Container Trailer" />
                          <FormControlLabel key="Tractor Only" value="Tractor Only" control={<Radio />} label="Tractor Only" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.calltypeError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.istrailer == "yes") || (this.state.dispatch.istrailer == "no")) && (
                      <FormControl component="fieldset" className={classes.formControl}  error={this.state.servicetypeError} helperText={this.state.servicetypeHelperText}>
                        <FormLabel component="legend">Type Of Service</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" row={true} value={this.state.dispatch.servicetype} onChange={this.handleServiceTypeChange}>
                          <FormControlLabel value="Jump" control={<Radio />} label="Jump" />
                          <FormControlLabel value="Flat" control={<Radio />} label="Flat" />
                          <FormControlLabel value="Winch" control={<Radio />} label="Winch" />
                          <FormControlLabel value="Service" control={<Radio />} label="Service" />
                          <FormControlLabel value="Lockout" control={<Radio />} label="Lockout" />
                        
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.servicetypeError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                
                </Grid>
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  <Grid item xs={6} sm={6}>
                    <TextField  required id="towreason" name="towreason" label="Reason For Tow"  error={this.state.towreasonError} helperText={this.state.towreasonHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.towreason} onChange={this.handleTowReasonChange}  />
                  </Grid>
                  
                  <Grid item xs={6} sm={6}>
                    <TextField  required id="safelocation" name="safelocation" label="Safe Location?" error={this.state.safelocationError} helperText={this.state.safelocationHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.safelocation} onChange={this.handleSafeLocationChange}  />
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    <TextField  required id="destination" name="destination" label="If Tow Destination"  error={this.state.destinationError} helperText={this.state.destinationHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.destination} onChange={this.handleDestinationChange}  />
                  </Grid>
                  
                  
                  
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.damage == "yes" ) ||(this.state.dispatch.damage == "no" ) )&&(
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.damageError} helperText={this.state.damageHelperText}>
                        <FormLabel component="legend">Damage?</FormLabel>
                        <RadioGroup aria-label="gender" name="Damage To Vehicle?"  value={this.state.dispatch.damage} onChange={this.handleDamageChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    { (this.state.dispatch.damage == undefined )&&(
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.damageError} helperText={this.state.damageHelperText}>
                        <FormLabel component="legend">Damage ?</FormLabel>
                        <RadioGroup aria-label="gender" name="Damage To Vehicle?"  value={this.state.dispatch.damage} onChange={this.handleDamageChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.damageError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.attended == "yes" ) ||(this.state.dispatch.attended == "no" ) )&&(
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.attendedError} helperText={this.state.attendedHelperText}>
                        <FormLabel component="legend">Attended?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.attended} onChange={this.handleAttendedChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    { (this.state.dispatch.attended == undefined)&&(
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.attendedError} helperText={this.state.attendedHelperText}>
                        <FormLabel component="legend">Attended ?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.attended} onChange={this.handleAttendedChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.attendedError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  { (this.state.dispatch.attended == "no" ) && (
                    <Grid item xs={6} sm={6}>
                      <TextField  required id="keylocation" name="keylocation" label="Key Location"   error={this.state.keylocationError} helperText={this.state.keylocationHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.keylocation} onChange={this.handleKeyLocationChange}  />
                    </Grid>
                  )}
                </Grid>
                
                
                <Grid item xs={12} sm={12}>
                  <Divider className={classes.dividerColor1}></Divider>
                </Grid>
                
                
                
                
                <Grid container spacing={24} style={{paddingLeft:10}}>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="contact" name="contact" label="Destination Contact" error={this.state.contactError} helperText={this.state.contactHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.contact} onChange={this.handleContactChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="requestedby" name="requestedby" label="Requested By" error={this.state.requestedbyError} helperText={this.state.requestedbyHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.requestedby} onChange={this.handleRequestedbyChange}  />
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="amountquoted" name="amountquoted" label="Amount Quoted " error={this.state.amountquotedError} helperText={this.state.ramountquotedHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.amountquoted} onChange={this.handleAmountquotedChange}  />
                  </Grid>
                  
                  
                  <Grid item xs={3} sm={3}>
                    { ((this.state.dispatch.paymentmethod != undefined) )&&(
                      <FormControl component="fieldset" className={classes.formControl}  required
                                   error={this.state.paymentmethodError}
                                   helperText={this.state.paymentmethodHelperText} >
                        <FormLabel component="legend" >Payment Method</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1"   row={true} value={this.state.dispatch.paymentmethod} onChange={this.handlePaymentMethodChange}>
                          <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                          <FormControlLabel value="Credit" control={<Radio />} label="Credit" />
                          <FormControlLabel value="Check" control={<Radio />} label="Check" />
                          <FormControlLabel value="Charge Account" control={<Radio />} label="Charge Account" />
                        </RadioGroup>
                      </FormControl>)}
                    { ((this.state.dispatch.paymentmethod == undefined) )&&(
                      <FormControl component="fieldset" className={classes.formControl}  required
                                   error={this.state.paymentmethodError}
                                   helperText={this.state.paymentmethodHelperText} >
                        <FormLabel component="legend" >Payment Method ?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1"   row={true} value={this.state.dispatch.paymentmethod} onChange={this.handlePaymentMethodChange}>
                          <FormControlLabel value="Cash" control={<Radio />} label="Cash" />
                          <FormControlLabel value="Credit" control={<Radio />} label="Credit" />
                          <FormControlLabel value="Check" control={<Radio />} label="Check" />
                          <FormControlLabel value="Charge Account" control={<Radio />} label="Charge Account" />
                        </RadioGroup>
                      </FormControl>)}
                    
                    {(this.state.paymentmethodError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    { (this.state.dispatch.paymentmethod == "Charge Account" ) && (
                      <TextField  required id="billto" name="billto" label="Bill To" error={this.state.billtoError}
                                  helperText={this.state.billtoHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.billto} onChange={this.handleBilltoChange}  />
                    )}
                    { (this.state.dispatch.paymentmethod != "Charge Account" ) && (
                      <TextField  required id="billto" name="billto" label="Bill To"  disabled={true} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.billto} onChange={this.handleBilltoChange}  />
                    )}
                  </Grid>
                  {/* FARSHID */}
                  <Grid item xs={2} sm={2}>
                    { ((this.state.dispatch.ispo == "yes" ) ||(this.state.dispatch.ispo == "no" ) )&&(
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.attendedError} helperText={this.state.attendedHelperText}>
                        <FormLabel component="legend">PO ?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.ispo} onChange={this.handleIspoChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    { (this.state.dispatch.ispo == undefined)&&(
                      
                      <FormControl required component="fieldset" className={classes.formControl} error={this.state.attendedError} helperText={this.state.attendedHelperText}>
                        <FormLabel component="legend">PO ?</FormLabel>
                        <RadioGroup aria-label="gender" name="gender1" value={this.state.dispatch.ispo} onChange={this.handleIspoChange}>
                          <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="no" control={<Radio />} label="No" />
                        </RadioGroup>
                      </FormControl>)}
                    {(this.state.ispoError)&&(
                      < Typography   style={{ color:'#f54242'}}
                                     variant = "body2"
                      >Please Select One < /Typography>)
                    }
                  </Grid>
                  { (this.state.dispatch.ispo == "yes" ) && (
                    
                    <Grid item xs={2} sm={2}>
                      <TextField  required id="ponumber" name="ponumber" label="P.O #" error={this.state.ponumberError} helperText={this.state.ponumberHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.ponumber} onChange={this.handlePONumberChange}  />
                    </Grid> )}
                  { (this.state.dispatch.ispo == "yes" ) && (
                    <Grid item xs={2} sm={2}>
                      <TextField  required id="policynumber" name="policynumber" label="Policy Number"  error={this.state.policynumberError} helperText={this.state.policynumberHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.policynumber} onChange={this.handlePolicyNumberChange}  />
                    </Grid>
                  )}
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="claimnumber" name="claimnumber" label="Claim Number" error={this.state.claimnumberError} helperText={this.state.claimnumberHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.claimnumber} onChange={this.handleClaimNumberChange}  />
                  </Grid>
                  
                  <Grid item xs={2} sm={2}>
                    <TextField  required id="overageamount" name="overageamount" label="Overage Amount"   error={this.state.overageamountError} helperText={this.state.overageamountHelperText}  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.overageamount} onChange={this.handleOverageamountChange}  />
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                  
                  <Grid item xs={8} sm={8}>
                    <TextField  required id="comment" name="comment" label="Comment"  fullWidth  multiline={true}
                                rows={2} InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.comment} onChange={this.handleCommentChange}  />
                  </Grid>
                  <Grid item xs={4} sm={4}>
                    <FormControl className={classes.formControl}  required
                    >
                      <InputLabel htmlFor="age-helper">Police</InputLabel>
                      <Select
                        value={this.state.selectedPolice}
                        onChange={this.handlePoliceChange}
                        inputProps={{
                          name: 'police',
                          id: 'police-helper'}}
                        error={this.state.selectedPoliceError}>
                        
                        {this.policeSelectList}
                      
                      </Select>
                      {/* <FormHelperText>Select a Company </FormHelperText>  */}
                    </FormControl>
                  
                  </Grid>
                  
                  <Grid item xs={12} sm={12}>
                    
                    <Divider className={classes.dividerColor1}></Divider>
                  </Grid>
                  
                  
                  {/*
        <Grid container spacing={24}>
                <Grid item xs={4} sm={4}>
                    <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-helper">Tow Company</InputLabel>
                        <Select
                        value={this.state.selectedCompany}
                        onChange={this.handleCompanyChange}
                            >

                            {this.companySelectList}


                            </Select>

                    </FormControl>
                </Grid>


                <Grid item xs={4} sm={4}>
                    <FormControl className={classes.formControl}  required
                        error={this.state.selectedPoliceError}
                        helperText={this.state.selectedPoliceHelperText} >
                    <InputLabel htmlFor="age-helper">Police</InputLabel>
                    <Select
                        value={this.state.selectedPolice}
                        onChange={this.handlePoliceChange}
                        inputProps={{
                            name: 'age',
                                id: 'age-helper',
                        }}
                            >

                    {this.policeSelectList}

                    </Select>

                    </FormControl>

                </Grid>
        </Grid>



            <Grid item xs={12} sm={12}>
            <Divider className={classes.dividerColor1}></Divider>
            </Grid>
            */}
                  
                  <Grid item xs={3} sm={3}>
                    <FormControl className={classes.formControl}  required
                    >
                      <InputLabel htmlFor="age-helper">Driver</InputLabel>
                      <Select
                        value={this.state.selectedDriver}
                        onChange={this.handleDriverChange}
                        inputProps={{
                          name: 'driver',
                          id: 'driver-helper',
                        }}
                        error={this.state.driverError} >
                        {this.driversSelectList}
                      
                      </Select>
                      {/* <FormHelperText>Select a Company </FormHelperText>  */}
                    </FormControl>
                  </Grid>
                  
                  <Grid item xs={3} sm={3}>
                    <FormControl className={classes.formControl}  required
                    >
                      <InputLabel htmlFor="age-helper">Truck</InputLabel>
                      <Select
                        value={this.state.selectedTruck}
                        onChange={this.handleTrucknumberChange}
                        inputProps={{
                          name: 'truck',
                          id: 'truck-helper',
                        }}
                        error={this.state.trucknumberError} >
                        
                        {this.trucksSelectList}
                      
                      </Select>
                      {/* <FormHelperText>Select a Company </FormHelperText>  */}
                    </FormControl>
                  </Grid>
                  
                  {/*
            <Grid item xs={3} sm={3}>
            <TextField  required id="driver" name="driver" label="Driver" error={this.state.driverError} helperText={this.state.driverHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.driver} onChange={this.handleDriverChange}  />
        </Grid>

        <Grid item xs={3} sm={3}>
            <TextField  required id="trucknumber" name="trucknumber" label="Truck Number" error={this.state.trucknumberError} helperText={this.state.trucknumberHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.trucknumber} onChange={this.handleTrucknumberChange}  />
        </Grid>
        */}
                  
                  
                  <Grid item xs={3} sm={3}>
                    <TextField  required id="dispatchedby" name="dispatchedby" label="Dispatched By" error={this.state.dispatchedbyError} helperText={this.state.dispatchedbyHelperText} fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.dispatch.dispatchedby} onChange={this.handleDispatchbyChange}  />
                  </Grid>
                  
                  
                  <Grid itemxs={3} sm={3} >
                    {/*} <MuiPickersUtilsProvider  utils={DateFnsUtils}  >
                        <KeyboardDateTimePicker
                        value={this.state.dispatch.dispatchdate}
                        onChange={this.handleDispatchDateChange}
                        label="Dispatch Time"
                        onError={console.log}
                        minDate={new Date("2018-01-01T00:00")}
                        format="yyyy/MM/dd hh:mm a"
                            />
                            </MuiPickersUtilsProvider>  */}
                    {/*}
                        <Typography variant="body2" >Dispatch Time</Typography>
                        <DatePickerB
                        selected={this.reformatDate(this.state.dispatch.dispatchdate)}
                        onChange={date => this.handleDispatchDateChange(date)}
                        showTimeSelect
                        timeIntervals={15}
                        timeCaption="time"
                        dateFormat="yyyy-MM-dd HH:mm:ss "
                            />  */}
                    
                    
                    <MuiPickersUtilsProvider  utils={DateFnsUtils}  >
                      
                      <KeyboardDateTimePicker
                        clearable
                        value={this.state.dispatch.dispatchdate}
                        onChange={this.handleDispatchDateChange}
                        label="Dispatch Date"
                        //onError={this.state.dispatchdateError}
                        error={this.state.dispatchdateError}
                        helperText={this.state.dispatchdateHelperText}
                        
                        format="yyyy/MM/dd hh:mm a"
                      />
                      {/*}
            <DatePicker
        margin="normal"
        id="date-picker-dialog"
        label="Dispatch Date"
        format="MM/dd/yyyy"
        value={this.state.dispatch.dispatchdate}
        onChange={this.handleDispatchDateChange}
        KeyboardButtonProps={{
            'aria-label': 'change date',
        }}
        required
        error={this.state.dispatchdateError}
        helperText={this.state.dispatchdateHelperText}
        /> */}
                    </MuiPickersUtilsProvider>
                  </Grid>
                  {/*
        <Grid itemxs={2} sm={2} >
            <MuiPickersUtilsProvider  utils={DateFnsUtils} >
            <TimePicker
        margin="normal"
        id="time-picker"
        label="Dispatch Time"
        value={this.state.dispatch.dispatchtime}
        onChange={this.handleDispatchTimeChange}
        KeyboardButtonProps={{
            'aria-label': 'change time',
        }}
        required
        error={this.state.dispatchtimeError} helperText={this.state.dispatchtimeHelperText}
        />
        </MuiPickersUtilsProvider>
        </Grid>*/}
                
                </Grid>
                
                {/*

                <Grid item xs={12}>
                    <TextField id="address2" name="address2" label="Address line 2" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedUser.address2} onChange={this.handleAddress2Change} />
                </Grid>
                */}
                
                <Grid container  style={{paddingLeft:10}}>
                  
                  <Grid item xs={3} sm={3}>
                    { ( ((this.state.dispatch.dispatchedby == null) || (this.state.dispatch.dispatchedby ==undefined)  )|| ((this.state.dispatch.status == undefined )|| (this.state.dispatch.status == 'Unknown') ) ) && (
                      <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                        Create
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Waiting') ) && (
                      <Button variant="contained" color="primary" onClick={this.handleDisptach} className={classes.button}  >
                        Dispatch
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Dispatched') ) && (
                      <Button variant="contained" color="primary" onClick={this.handleEnroute} className={classes.button}  >
                        En Route
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Enroute') ) && (
                      <Button variant="contained" color="primary" onClick={this.handleOnscene} className={classes.button}  >
                        On Scene
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Onscene') ) && (
                      <Button variant="contained" color="primary" onClick={this.handleTowing} className={classes.button}  >
                        Towing
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Towing') ) && (
                      <Button variant="contained" color="primary" onClick={this.handleCompleted} className={classes.button}  >
                        Completed
                      </Button>)}
                    { ((this.state.dispatch.dispatchedby != null) && (this.state.dispatch.dispatchedby !=undefined) && (this.state.dispatch.status == 'Complete') ) && (
                      <Button variant="contained" color="primary"  className={classes.button}  >
                        No Action
                      </Button>)}
                    
                  </Grid>
                  <Grid item xs={3} sm={3}>
                    <Button variant="contained" color="primary" className={classes.button}  onClick={() => this.handleClickShowDispatchLog()}>
                     Show Dispatch Log
                    </Button>
                  </Grid>
                  
                  
                  <Grid item xs={3} sm={3}>
                    <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                      Clear Fields
                    </Button>
                  </Grid>
                  <Grid item xs={3} sm={3} >
                    <FilePicker
                      extensions={['jpg']}
                      onChange={(FileObject) => {this.handleUploadSelectedFile(FileObject)}}
                    >
                      <Button variant="contained" color="primary" className={classes.button}  >
                        Picture to upload
                      </Button>
                    </FilePicker>
                  </Grid>
                  <Grid item xs={3} sm={3}  style={{paddingBottom:20}}>
                    {/* <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                        Refresh Screen
                    </Button> */}
                    {/*}
                        <Avatar alt="Remy Sharp" src="http://localhost:8080/files1" />
                        
    
                
                    <Image
                        src="http://localhost:8080/files1"
                            />
                            */}
                  </Grid>
                  <Grid item xs={2} sm={2}>
                    
                    <Dialog
                      open={this.state.showFormDialog}
                      onClose={this.handleClickShowFormDialogClose}
                      scroll={'paper'}
                      aria-labelledby="scroll-dialog-title"
                      aria-describedby="scroll-dialog-description"
                    >
                      <DialogTitle id="scroll-dialog-title">Dispatch Log Sheet</DialogTitle>
                      <DialogContent  id="farshids"   dividers={true}>
                        
                        <Document
                          file={this.props.dispatchsheetPath}
                          onLoadSuccess={this.onDocumentLoadSuccess}
                        >
                          <Page   scale={1.0} pageNumber={1} />
                        </Document>
                      </DialogContent>
                      <DialogActions>
                        <Tooltip title="Download to Print Dispatch Log Sheet">
                          <Button  color="primary" onClick={this.downloadDispatchData}>Download</Button>
                        </Tooltip>
                        
                        <Button onClick={this.handleClickShowFormDialogClose} color="secondary">Close</Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>
                </Grid>
                <Grid item xs={1} sm={1} >
                </Grid>
                
                
                
                <Grid container >
                  { (this.props.errorCMsg) && (this.props.errorCMsg.message) && (
                    <Grid item xs={12}   >
                      <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                                 className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                  }
                
                </Grid>
              </Grid>
              
              <Dialog
                open={this.state.open}
                TransitionComponent={Transition}
                keepMounted
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle id="alert-dialog-slide-title" className={classes.dialogheader}>{"Incomplete Form"}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description"  className={classes.dialogtext}>
                    The form is not complete yet. Please fill out the fields that are marked. You need to RESELECT the DATES in this form.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary">
                    Close
                  </Button>
                
                </DialogActions>
              </Dialog>
              
              <Dialog
                open={this.state.showDispatchSavedDialog}
                onClose={this.handleClickShowSavedDispatchClose}
                scroll={'paper'}
                classes={{
                  paper: classes.formControl2,
                }}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                maxWidth="xl"
              >
                <DialogTitle id="scroll-dialog-title">Tow Job action</DialogTitle>
                <DialogContent  id="farshids"   dividers="paper">
                  
                  {(this.props.errorCMsg.status == 200) &&	(<div>
                    The Operation was SUCCESSFUL! Please refresh the list by pressing the refresh button -  {this.props.errorCMsg.status}  {this.props.errorCMsg.statusText}
                  </div>) }
                  {(this.props.errorCMsg.status != 200) && (this.props.errorCMsg.status != null) 	 && (<div>
                    The Operation FAILED, please try again! -  {this.props.errorCMsg.status} - {this.props.errorCMsg.statusText}
                  </div>) }
                
                </DialogContent>
                <DialogActions>
                  {/*
					<Tooltip title="Selected entities will receive police notice">
						<Button  color="primary" onClick={this.sendEmail}>Send EMAIL</Button>
					</Tooltip>
					*/}
                  
                  <Button onClick={this.handleClickShowSavedDispatchClose} color="secondary">Close</Button>
                </DialogActions>
              </Dialog>
            
            
            
            </Grid>
          </Grid>
        
        
        
        </React.Fragment>
      </form>
    );
  }//end of render
  
  handleEditModeChange(){
    //this.isTruckRef.current.value = this.props.passedDispatchLog.istruck;
    this.setState({clearFields:false});
    this.props.onEdit();
    //this.isTruckRef.current = this.props.passedDispatchLog.istruck;
  }
  
  
  /* editRecord(singleRowData){
			 this.setState({inputFieldShrinkState:true});
			 //this.setState({dispatch:singleRowData });
			 //this.setState(Object.assign(this.state.dispatch,{calltype:"Landoll"}));
					 if(this.setState.alterState == false){
							 this.setState({alterState:true });
					 }else{
							 this.setState({alterState:false });
					 }
					 this.setState({clearFields:false});

	 }*/
  
  componentWillReceiveProps(nextProps)
  {
    
    let {loadPoliceData, updateADispatchsheetPath,loadTowCompanyDriversData,loadTowCompanyTrucksData} = this.props;
    let {decodeVin} = this.props;
    
    
    if (this.state.clearFields == false) {
      if (this.props.passedDispatchLog !== nextProps.passedDispatchLog) {
        this.setState({
          dispatch: nextProps.passedDispatchLog
        });
      }
    }
    var tempdispatch = nextProps.passedDispatchLog;
    /*if(tempdispatch.istruck == undefined){
		tempdispatch = this.state.dispatch;
		}*/
    
    if (this.state.clearFields == false) {
      this.setState({
        dispatch: tempdispatch
      });
      /*if(tempdispatch.vin != null) {
				decodeVin(tempdispatch.vin);
			} */
    }
    
    // this.isTruckRef.current.value = nextProps.passedDispatchLog.istruck;
    
    if (this.props.passedDispatchLog != undefined) {
      var tempPolice = this.getPoliceInfoFromPoliceId(nextProps.passedDispatchLog.policeid);
      this.setState({
        selectedPolice: tempPolice
      });
      
      var tempDriver = this.getDriverInfoFromDriverId(nextProps.passedDispatchLog.driverid);
      this.setState({
        selectedDriver: tempDriver
      });
      
      var tempTruck = this.getTruckInfoFromDriverId(nextProps.passedDispatchLog.truckid);
      this.setState({
        selectedTruck: tempTruck
      });
      
      this.setState({selectedVehicleCountry: nextProps.passedDispatchLog.country});
      this.setState({selectedVehicleState: nextProps.passedDispatchLog.state});
      updateADispatchsheetPath(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany, nextProps.passedDispatchLog.id);
    }
    
    /*  Farshid Look at this later . if(this.props.passedDispatchLog != undefined) {
var tempCompany =this.getCompanyInfoFromCompanyId(nextProps.passedDispatchLog.towcompanyid);
this.setState({
selectedCompany: tempCompany
});
} */
    
    if ((this.props.selectedCompany != nextProps.selectedCompany)) {
      
      loadPoliceData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany);
      loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany);
      loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany);
      
    }
    /*if ((nextProps.passedDispatchLog.vin != this.props.passedDispatchLog.vin)) {
				decodeVin(nextProps.passedDispatchLog.vin);
		}*/
    
    
    if (this.setState.alterState == false) {
      this.setState({alterState: true});
    } else {
      this.setState({alterState: false});
    }
    
    if(nextProps.errorCMsg.status != null) {
      if (nextProps.errorCMsg.status != null) {
        this.handleClickShowSavedDispatch();
      }
    }
    
    
  }
  
  
  componentDidMount()
  {
    
    
    //this.isTruckRef.current.value = this.props.passedDispatchLog.istruck;
    
    
    //let {loadSingleUserData, loadUsersData ,loadVehiclesData ,loadPoliceData, loadLocationsData,loadCompanysData  } = this.props;
    if (this.props.passedDispatchLog != undefined) {
      var tempPolice = this.getPoliceInfoFromPoliceId(this.props.passedDispatchLog.policeid);
      this.setState({
        selectedPolice: tempPolice
      });
      
      var tempDriver = this.getDriverInfoFromDriverId(this.props.passedDispatchLog.driverid);
      this.setState({
        selectedDriver: tempDriver
      });
      
      var tempTruck = this.getTruckInfoFromDriverId(this.props.passedDispatchLog.truckid);
      this.setState({
        selectedTruck: tempTruck
      });
      
      this.setState({selectedVehicleCountry: this.props.passedDispatchLog.country});
      this.setState({selectedVehicleState: this.props.passedDispatchLog.state});
    }
    
    if (this.state.clearFields == false) {
      this.setState({dispatch: this.props.passedDispatchLog});
    }
    
    
    
  }
  
  
  deleteRecord(argProcessId)
  {
    //alert('I am deleting ' + argCameraId);
    let {deleteAUser} = this.props;
    deleteAUser(DEFAULT_VESPAAN_SERVER.url, argProcessId);
  }
  
  
  
  
  
  componentWillMount(){
    let { loadSingleUserData , loadPoliceData, loadTowCompanyDriversData,loadTowCompanyTrucksData } = this.props;
    loadSingleUserData(DEFAULT_VESPAAN_SERVER.url );
    if(this.props.selectedCompany !== null) {
      loadPoliceData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany);
      loadTowCompanyDriversData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany);
      loadTowCompanyTrucksData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany);
    }
    //loadLocationsData("http://localhost:9065/" );
    if(this.state.clearFields == false) {
      this.setState({dispatch: this.props.passedDispatchLog});
    }
    /*if((this.isTruckRef.current != undefined) || (this.isTruckRef.current != null)) {
				this.isTruckRef.current.value = this.props.passedDispatchLog.istruck;
		}*/
    this.setState({
      errorCMsg:{}
    });
  }
  
  
  
}//end of class

DispatcherLogform.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    usersArray: state.user.usersArray,
    UserDeleteResponse:state.user.deleteUserResp,
    UserSaveResponse:state.user.saveUserResp,
    saveUserResp:state.user.saveUserResp,
    companysArray: state.company.companysArray,
    selectedCompany:state.company.selectedCompany,
    policeArray: state.police.policeArray,
    decodedVinVehicleObject: state.vin.decodedVinVehicleObject,
    dispatchsheetPath:state.dispatchsheet.dispatchsheetPath,
    saveDispatchsheetResponse:state.dispatchsheet.saveDispatchsheetResponse,
    policeNoticePath:state.policenotice.policeNoticePath,
    towcompanytrucksArray: state.towcompanytruck.towcompanytrucksArray,
    towcompanydriversArray: state.towcompanydriver.towcompanydriversArray,
    errorCMsg:state.dispatchsheet.errorCMsg,
  };
};
////file={this.props.dispatchsheetPath}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loadUsersData:loadUsersData,
    loadSingleUserData:loadSingleUserData,
    deleteAUser:deleteAUser,
    saveAUser:saveAUser,
    updateAUser:updateAUser,
    selectACompany:selectACompany,
    loadCompanysData:loadCompanysData,
    loadPoliceData:loadPoliceData,
    decodeVin:decodeVin,
    saveADispatchsheet:saveADispatchsheet,
    updateADispatchsheetPath:updateADispatchsheetPath,
    updateADispatchsheet:updateADispatchsheet,
    loadDispatchsheetsData:loadDispatchsheetsData,
    clearDispatchErrorMsg:clearDispatchErrorMsg,
    uploadATowPicture:uploadATowPicture,
    loadTowCompanyDriversData: loadTowCompanyDriversData,
    loadTowCompanyTrucksData: loadTowCompanyTrucksData,
    
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DispatcherLogform));
